/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .controller('PlaybackController', function ($scope, $compile, $http, $rootScope, $state, $stateParams, $window, $timeout, Principal, CollectionService, AssetService, BaseFileService, Auth, Tenant, DownloadableMedia, atmosphereService) {
        Principal.identity().then(function(account) {

            var logger = function(msg) {
                var active = false;

                if(active) {
                    console.log(msg);
                }
            }
            
            $scope.isAuthenticated = Principal.isAuthenticated;
            $scope.isContentManager = false;
            $scope.hideHeaderAndFooter = $rootScope.hideHeaderAndFooter;
            $scope.breadcrumbLoaded = false;
            $scope.contentLoaded = false;
            $scope.render = false;
            $scope.enableQuizzing = false;
            $scope.showAudioTracks = false;

            $http({
                method: 'GET',
                url: 'api/properties?name=ENABLE_QUIZZING'
            }).then(function successCallback(response) {
                $scope.enableQuizzing = response.data.value === "true";

                if (response.data.value === "admin") {
                    var isQuizzingAdmin = Principal.hasAnyAuthority(["ROLE_QUIZZING_ADMIN"]);
                    if (isQuizzingAdmin) {
                        $scope.enableQuizzing = true;
                    }
                }
            });
            
            $scope.flagVjsPlayer = false;
            $http({method: 'GET', url: 'api/properties?name=FEATURE_FLAG_VJS_PLAYER'})
                .then(function (response) {
                    if (response.data.value !== null && response.data.value === "true") {
                        $scope.flagVjsPlayer = true;
                        //console.log("-------------Using VjsPlayer-------------\n");
                    }
                });
            
            if($window.location.hash.indexOf("#/lms/playback/") === 0) {
                //lms
                $scope.rootCollectionType = $rootScope.rootCollectionType;
            } else {
                //standalone
                if($window.location.hash.indexOf('course') > -1) {
                    $scope.rootCollectionType = 'course';
                }

                if($window.location.hash.indexOf('protected') > -1) {
                    $scope.rootCollectionType = 'collection';
                }

                if($window.location.hash.indexOf('collection') > -1) {
                    $scope.rootCollectionType = 'collection';
                }

                if($window.location.hash.indexOf('channel') > -1) {
                    $scope.rootCollectionType = 'channel';
                }
            }

            $http({
                method: 'GET',
                url: 'api/properties?name=FEATURE_FLAG_AUDIO_TRACKS'
            }).then(function successCallback(response) {
                $scope.showAudioTracks = response.data.value === "true";
            });

            Tenant.info().then(function(tenant) {

                $scope.tenant = tenant;

                if (self === top && $window.location.hash.indexOf("#/lms/playback/") === 0) {

                    if ($scope.isAuthenticated()) {
                        Auth.logout();
                    }

                    $rootScope.previousStateName = undefined;

                    $rootScope.previousStateParams = undefined;

                    var managerUrl = $scope.tenant.managerUrl;

                    // logout of MediaManager and redirect to PPnP
                    if (managerUrl) {
                        $http.get($scope.tenant.managerUrl + '/j_acegi_logout', {withCredentials: true});
                        $window.location.href = managerUrl.substring(0, managerUrl.lastIndexOf('/'));
                    }

                } else {

                    $scope.account = account;
                    $scope.userFullName = "Anonymous User";
                    $scope.userName = "anonymousUser";

                    //Atmosphere set up for caption complete notification
                    var atmosphereSetup = function() {
                        logger('atmosphereSetup')
                        if(!$scope.account) {
                            return;
                        }
                        var request = {
                            url: './notification/'+$scope.asset.createdBy,
                            contentType: 'application/json',
                            logLevel: 'debug',
                            transport: 'websocket',
                            fallbackTransport: 'streaming',
                            trackMessageLength: true,
                            reconnectInterval: 5000,
                            enableXDR: true,
                            timeout: 300000,
                            shared: true
                        };

                        request.onOpen = function(response) {
                            logger('onOpen')
                            console.log('Atmosphere connected using ' + response.transport);
                        };

                        request.onMessage = function(response){
                            logger('onMessage')
                            try{

                                var message = JSON.parse(response.responseBody);

                                if(message.messageType === 'caption'){
                                    if(message.responseType === 'success'){
                                        console.log("Closed Captions Available");
                                        $scope.asset.transcriptAvailable = true;

                                        //update the status in datatable for the corresponding language (English)
                                        //refresh flowplayer so captions show up in menu
                                        $scope.captionsupdated = false;
                                        getAsset(true);
                                        setTimeout(() => {
                                            $scope.captionsupdated = true;
                                        }, 500);
                                    } else if(message.responseType === 'failure'){
                                        console.error("Captioning Failed");
                                    }
                                }
                            }catch(err) {
                                console.log(err.message);
                            }
                        };

                        request.onClientTimeout = function(response){
                            logger('onClientTimeout')
                            setTimeout(function(){
                                atmosphereService.subscribe(request);
                            }, request.reconnectInterval);
                        };

                        atmosphereService.subscribe(request);
                    };

                    $http({
                        method: 'GET',
                        url: 'api/user/iscontentmanager'
                    }).then(function successCallback(response) {
                        $scope.isContentManager = response && response.data;
                    });

                    /*
                     Parse comments for hh:mm:ss or mm:ss timestamps and convert these timestamps into links which let you seek to that point in the audio/video
                     */
                    var parseComments = function (comments) {
                        // This is the regex for recognizing the hh:mm:ss or mm:ss pattern
                        var timeRegex = /([012]?\d?:?[0-5]?\d:[0-5]?\d)/;
                        // Loop over each comment and parse it so that timestamps are converted into links
                        comments.forEach(function (comment) {
                            var commentText = comment.commentText,
                                parts = commentText.split(timeRegex),
                                newCommentText = "";

                            for (var i = 0; i < parts.length; i++) {
                                if (/^[012]?\d?:?[0-5]?\d:[0-5]?\d$/.test(parts[i])) {
                                    newCommentText = newCommentText.concat("<a ng-click=\"jumpPlaybackTo('" + parts[i] + "')\">" + parts[i] + "</a>");
                                } else {
                                    newCommentText = newCommentText.concat(parts[i]);
                                }
                            }
                            comment.commentText = newCommentText;

                        });
                        return comments;
                    };

                    if($scope.isAuthenticated()) {
                        $scope.userName = $scope.account.login;
                        if ($scope.account.firstName || $scope.account.lastName) {
                            $scope.userFullName = $scope.account.firstName ? $scope.account.firstName : "";
                            $scope.userFullName += $scope.account.lastName ? " " + $scope.account.lastName : $scope.account.lastName;
                        } else {
                            $scope.userFullName = $scope.userName;
                        }
                    }

                    var collectionId = $scope.collectionId = $state.params.collectionId,
                        assetId = $state.params.assetId,
                        collectionType = $scope.collectionType = $state.params.collectionType;

                    $scope.collectionContent = [];

                    $scope.getCollectionContent = function() {
                        CollectionService.GetCollectionContentItem.get({
                            cid: $scope.currentCollection.cid,
                            aid: $scope.asset.aid,
                            isActive: $scope.asset.isActive,
                        }, function (result) {
                            $scope.collectionContent = result.contents;
                            $scope.contentLoaded = true;
                        });
                    }

                    $scope.getCollections = function() {
                        logger('getCollections')

                        CollectionService.GetCollection.get({
                            cid: collectionId,
                            type: collectionType.toUpperCase()
                        }, function (parentCollection) {
                            $scope.parent = parentCollection;
                            $scope.parentCollection = parentCollection;
                            $scope.currentCollection = parentCollection;
                            $scope.isMediaInboxCollection = $scope.currentCollection.type === 'dropbox' ||
                                                            $scope.currentCollection.type === 'assignment' ||
                                                            $scope.currentCollection.type === 'zoom';

                            var collectionTreeIntervalId = setInterval(function () {
                                if($scope.collectionTree) {
                                    clearInterval(collectionTreeIntervalId);
                                    $scope.currentCollection.crumbs = generateCrumbs(parentCollection.cid, parentCollection.path);
                                    $scope.showBreadcrumbEllipsis = $scope.currentCollection.crumbs.length > 1;

                                    //show only last 2 subfolders
                                    $scope.breadcrumbFolders = $scope.currentCollection.crumbs.slice($scope.currentCollection.crumbs.length - 1, $scope.currentCollection.crumbs.length);
                                    $scope.crumbsForMenu = JSON.parse(JSON.stringify($scope.currentCollection.crumbs.slice(0, $scope.currentCollection.crumbs.length - 1)));

                                    setTimeout(function(){
                                        manageBreadcrumbTruncation();
                                    }, 500)
                                }
                            }, 50);

                            $scope.currentCollection.pathLength = parentCollection.path.split('/').length;
                            $scope.getCollectionContent();
                            var arrPath = parentCollection.path.split('/');
                            if(arrPath.length > 2) {

                                if($scope.rootCollectionId) {
                                    CollectionService.GetCollection.get({
                                        cid: $scope.rootCollectionId,
                                        type: collectionType.toUpperCase()
                                    }, function (collection) {
                                        $scope.collection = collection;
                                        $rootScope.rootLevelCollectionTitle = collection.title;
                                        $scope.breadcrumbLoaded = true;
                                    });
                                }

                            } else {
                                if(!$scope.rootCollectionId) {
                                    $scope.rootCollectionId = $scope.asset.cid;
                                }

                                CollectionService.GetCollection.get({
                                    cid: $scope.rootCollectionId,
                                    type: collectionType.toUpperCase()
                                }, function (collection) {
                                    $scope.collection = collection;
                                    $rootScope.rootLevelCollectionTitle = collection.title;
                                    $scope.breadcrumbLoaded = true;
                                });
                            }
                        });
                    }

                    var manageBreadcrumbTruncation = function() {
                        var assetTitleIntervalId = setInterval(function() {
                            if($('.breadcrumb .asset-name .name').length) {
                                clearInterval(assetTitleIntervalId);

                                var breadcrumbInterval = setInterval(function() {
                                    if(
                                        $('.breadcrumb .sub-folder .name').height() > 0 ||
                                        $('.breadcrumb .current-folder .name').height() > 0 ||
                                        $('.breadcrumb .asset-name .name').height() > 0
                                    ) {
                                        clearInterval(breadcrumbInterval);

                                        //If the breadcrumb is bigger than the max width
                                        var isBreadcrumbBigger = $('.breadcrumb .sub-folder .name').height() > 28 ||
                                            $('.breadcrumb .current-folder .name').height() > 28 ||
                                            $('.breadcrumb .asset-name .name').height() > 28;

                                        if(isBreadcrumbBigger) {
                                            //If each subfolder is bigger than the limit
                                            if(
                                                hasEllipsisWidth( $('.breadcrumb .sub-folder')[0] ) ||
                                                hasEllipsisWidth( $('.breadcrumb .current-folder')[0] ) ||
                                                hasEllipsisHeight( $('.breadcrumb .asset-name')[0] )
                                            ) {

                                                //Add ellipsis to subfolders that are wider than the limit
                                                $('.breadcrumb .sub-folder .name').addClass('truncate-ellipsis');
                                                $('.breadcrumb .sub-folder .name').addClass('limit-folder-size');
                                                $('.breadcrumb .current-folder .name').addClass('truncate-ellipsis');
                                                $('.breadcrumb .current-folder .name').addClass('limit-folder-size');

                                                //TODO: get player width - .root-container width
                                                var nameWidthIntervalId = setInterval(function() {
                                                    if( $('.breadcrumb .root-collection .name').width() ) {
                                                        clearInterval(nameWidthIntervalId);

                                                        var subFoldersWidth = 0;
                                                        $('.breadcrumb .sub-folder').each(function(index, item) {
                                                            subFoldersWidth += $(item).width() + 16;
                                                        });

                                                        // var assetNameWidth = $('#player').width() - titleWidth - subFoldersWidth - 40;
                                                        var assetNameWidth = 187;

                                                        $('.breadcrumb .asset-name .name').addClass('truncate-ellipsis');
                                                        $('.breadcrumb .asset-name .name').css('max-width', assetNameWidth.toString() + 'px');
                                                    }
                                                }, 10)
                                            }

                                            $scope.showSubFolderTooltip = [];


                                            if($('.breadcrumb .sub-folder').length > 0) {
                                                $scope.showSubFolderTooltip[0] = hasEllipsisWidth( $('.breadcrumb .sub-folder .name')[0] );
                                            }

                                            if($('.breadcrumb .sub-folder').length > 1) {
                                                $scope.showSubFolderTooltip[1] = hasEllipsisWidth( $('.breadcrumb .sub-folder .name')[1] );
                                            }

                                            if($('.breadcrumb .sub-folder').length > 2) {
                                                $scope.showSubFolderTooltip[2] = hasEllipsisWidth( $('.breadcrumb .sub-folder .name')[2] );
                                            }
                                        }

                                        if(hasEllipsisWidth($('.breadcrumb .current-folder .name')[0])) {
                                            $scope.showCurrentFolderTooltip = true;
                                        }

                                        setTimeout(function() {
                                            if(hasEllipsisWidth($('.breadcrumb .asset-name .name')[0])) {
                                                $scope.showAssetTooltip = true;
                                            }
                                        }, 1000)

                                        $('.breadcrumb').css('opacity', 1);
                                    }
                                }, 50)
                            }
                        }, 10)
                    }

                    $scope.handleMenuToggleActiveKeyPress = function(e, active) {
                        if(e.which === 13) {
                            $scope.toggleActive(e, active);
                        }
                    }

                    $scope.toggleActive = function(e, active) {
                        if($scope.logEventHandlers) {
                            console.log('publishItem')
                        }

                        if (!active) {
                            var assetActiveStatusDTO = {
                                assetId: $scope.asset.aid,
                                active: active,
                            }
                            AssetService.SetActiveStatus.send(assetActiveStatusDTO, function (response) {
                                getAsset();
                            });
                        }
                        else {
                            $scope.openModal("Publish");
                        }
                    }

                    $scope.createQuiz = function(e) {
                        if($scope.logEventHandlers) {
                            console.log('createQuiz')
                        }
                        var newQuizMM = {
                            cid: $scope.asset.cid,
                            parentAssetId: $scope.asset.aid,
                        }
                        AssetService.NewQuizMM.send(newQuizMM, function (response) {
                            $scope.quizAid = response.aid;
                            $scope.quizCid = response.cid;
                            var newQuizMC = {
                                collectionId: response.cid,
                                assetId: response.aid,
    //                            token: $rootScope.launchToken,
    //                            state: $rootScope.launchState
                            }
                            AssetService.CreateQuiz.send(newQuizMC, function (response) {
                                var addQuizSettings = {
                                    quizId: response.id,
                                    allowSkipping: false,
                                    shuffleAnswers: false,
                                    allowChanges: false,
                                    showCorrectAnswer: false,
                                    showFeedbackAnswerSubmission: false,
                                    showResultsQuizSubmission: false,
                                    answerSubmissions: '0',
                                    quizSubmissions: '1'
                                }
                                AssetService.AddQuizSettings.send(addQuizSettings, function (response) {
                                    $state.go('quizzing', {
                                        collectionId: $scope.quizCid,
                                        assetId: $scope.quizAid,
                                        collectionType: 'course',
                                        isNewQuiz: true,
                                        isFromPnP: false
                                    });
                                });
                            });
                        });
                    }

                    $scope.$watch("render", function () {
                        if ($scope.render) getAsset();
                        $scope.render = false;
                    });

                    $scope.$watch('[parent, asset]', function(){
                        if($scope.parent && $scope.asset){
                            // Get a few assets from the same parent collection to display in the sidebar
                            AssetService.GetAllAssets.get({cid: $scope.parent.cid, isActive: $scope.asset.isActive}, function (assetList) {
                                $scope.assets = assetList.assets;

                                setTimeout(() => {
                                    //Add ellipsis for long titles
                                    $('.sidebar-courses .course-title a').each((index, item) => {
                                        $clamp(item, {clamp: 2});
                                    });

                                    //Add tooltip if there's ellipsis in title
                                    $('.sidebar-courses .course-title a').each((index, item) => {
                                        if(hasEllipsisHeight(item)) {
                                            $scope.assets[index].hasEllipsis = true;
                                        }
                                    });

                                }, 0)
                            });
                        }
                    });

                    $scope.movingAsset = $rootScope.movingAsset;

                    var hasEllipsisHeight = function(element) {
                        var contentElement = $(element)[0];
                        var scrollHeight = contentElement && contentElement.scrollHeight;
                        var offsetHeight = contentElement && contentElement.offsetHeight;

                        return scrollHeight > offsetHeight;
                    }

                    var hasEllipsisWidth = function(element) {
                        var contentElement = $(element)[0];
                        var scrollWidth = contentElement && contentElement.scrollWidth;
                        var offsetWidth = contentElement && contentElement.offsetWidth;

                        return scrollWidth > offsetWidth;
                    }

                    // The maximum number of characters a comment can have
                    $scope.maxCommentLength = 255;

                    // For comments pagination
                    $scope.commentsPerPage = 5;
                    $scope.currentPage = 0;
                    $scope.captionsList = [];
                    $scope.assetHasCaptions = false;
                    $scope.audioTracksList = [];
                    $scope.assetHasAudioTracks = false;
                    $scope.audioTrackMode = 'list';
                    $scope.audioTrackUpload = {
                        file: null,
                        fileName: '',
                        language: null,
                        type: null
                    };
                    $scope.audioTrackUploadError = null;
                    $scope.audioTrackUploading = false;
                    $scope.audioTrackFileExtensionNotSupported = false;
                    var defaultAudioTrackLanguage = null;
                    var supportedAudioExtensions = ['mp3','m4a','aac','wav','wma','flac','ogg'];
                    $scope.audioTrackTypes = ['Audio', 'Audio Description'];
                    var defaultAudioTrackType = 'Audio Description';

                    var setDefaultAudioTrackLanguage = function() {
                        if(defaultAudioTrackLanguage) {
                            $scope.audioTrackUpload.language = defaultAudioTrackLanguage;
                        } else {
                            $scope.audioTrackUpload.language = null;
                        }
                    };

                    var setDefaultAudioTrackType = function() {
                        $scope.audioTrackUpload.type = defaultAudioTrackType;
                    };

                    var clearAudioTrackFileInput = function() {
                        var input = document.getElementById('audioTrackFileInput');
                        if(input) {
                            input.value = null;
                        }
                    };

                    var resetAudioTrackUploadState = function(keepSelections) {
                        $scope.audioTrackUpload.file = null;
                        $scope.audioTrackUpload.fileName = '';
                        $scope.audioTrackFileExtensionNotSupported = false;
                        $scope.audioTrackUploadError = null;
                        clearAudioTrackFileInput();
                        if(!keepSelections) {
                            setDefaultAudioTrackLanguage();
                            setDefaultAudioTrackType();
                        }
                    };

                    var reloadPlayerAfterAudioTrackChange = function(delay) {
                        var timeoutDelay = angular.isDefined(delay) ? delay : 0;
                        $scope.captionsupdated = false;
                        $timeout(function() {
                            $scope.captionsupdated = true;
                        }, timeoutDelay);
                    };

                    var isAudioExtensionSupported = function(fileName) {
                        if(!fileName) {
                            return false;
                        }
                        var segments = fileName.split('.');
                        if(segments.length < 2) {
                            return false;
                        }
                        var extension = segments.pop().toLowerCase();
                        return supportedAudioExtensions.indexOf(extension) > -1;
                    };

                    var attachAudioTrackFileInputListener = function() {
                        $timeout(function waitForAudioInput() {
                            var input = document.getElementById('audioTrackFileInput');
                            if(!input) {
                                $timeout(waitForAudioInput, 100);
                                return;
                            }
                            if(input._hasAudioTrackListener) {
                                return;
                            }
                            input._hasAudioTrackListener = true;
                            input.addEventListener('change', function(event) {
                                var files = event.target.files;
                                $scope.$apply(function() {
                                    if(files && files.length) {
                                        var file = files[0];
                                        $scope.audioTrackUpload.file = file;
                                        $scope.audioTrackUpload.fileName = file.name;
                                        $scope.audioTrackFileExtensionNotSupported = !isAudioExtensionSupported(file.name);
                                        if($scope.audioTrackFileExtensionNotSupported) {
                                            $scope.audioTrackUploadError = 'Unsupported file type. Please upload an MP3, M4A, AAC, WAV, WMA, FLAC, or OGG file.';
                                        } else {
                                            $scope.audioTrackUploadError = null;
                                        }
                                    } else {
                                        resetAudioTrackUploadState(true);
                                    }
                                });
                            });
                        }, 0);
                    };
                    //send to watson button or not
                    $scope.sentForCaptioning = false;
                    $scope.receivedFromCaptioning = false;
                    $scope.tickedForCaptioning = false;
                    $scope.captionsupdated = false;
                    //send for captioning to captionsync
                    $scope.sentForCaptioningCs = false;
                    //show send to watson button
                    $scope.showWatsonButton = false;
                    $scope.showCaptionsyncButton = false;
                    $scope.addCaptionsText = 'To add captions, select “Upload Captions“ if you have a captions file for this media asset on your computer.';


                    // Get the asset to be displayed
                    var getAsset = function (shouldShowRecentlyGeneratedCaptions) {
                        logger('getAsset');
                        $http({
                            method: 'GET',
                            url: 'api/user/checkforcaptionsyncaccount'
                        }).then(function successCallback(response) {
                            $scope.showCaptionsyncButton = response && response.data.body == 'true';
                        });
                        AssetService.GetAsset.get({cid: collectionId, aid: assetId}, function (asset) {
                            $scope.asset = asset;

                            if (asset.type === 'Video' || asset.type === 'Audio') {
                                $scope.mediaType = 'av';
                                if($scope.isAuthenticated()){
                                    if($scope.account.allowCaptionService
                                        && $scope.tenant.captioningServiceList.length
                                        && ($scope.tenant.captioningServiceList.indexOf('WATSON') > -1 || $scope.tenant.captioningServiceList.indexOf('REV') > -1)){
                                        $scope.showWatsonButton = true;
                                    }
                                }
                            }

                            if(asset.ccAvailable){
                                console.log("Closed Captions Available");
                            }

                            $scope.getCollectionTree();

                            // Get the asset comments
                            AssetService.GetComments.query({
                                cid: collectionId,
                                aid: assetId,
                                offset: $scope.currentPage * $scope.commentsPerPage,
                                limit: $scope.commentsPerPage
                            }, function (comments) {
                            $scope.comments = $scope.mediaType === 'av' ? parseComments(comments) : comments;
                        });

                        $scope.getCaptionsForAsset(shouldShowRecentlyGeneratedCaptions);
                        $scope.getAudioTracksForAsset();
                        $scope.captionsupdated = true;
                            if ($scope.asset.hfId && (!$scope.asset.ccAvailable || $scope.captionsList.length == 0) && !$scope.sentForCaptioning &&!$scope.tickedForCaptioning && $scope.showWatsonButton) {
                                $scope.addCaptionsText = 'To add captions, select “Generate Captions” or “Upload Captions“ if you have a captions file for this media asset on your computer.';
                            }

                            //check if the file was checked for captioning
                            BaseFileService.GetMCBaseFile.get({id: asset.hfId}, function(result){
                                $scope.sentForCaptioning = result.sendForCaptioning;
                                $scope.receivedFromCaptioning = result.receivedFromCaptioning;
                                $scope.sentForCaptioningCs = result.sendForCaptioningCs;

                                if($scope.sentForCaptioning && !$scope.receivedFromCaptioning){
                                    console.log("file was sent for captioning - " + $scope.sentForCaptioning);
                                    console.log("Sent for captioning.  Generating Captions...");
                                    $scope.tickedForCaptioning = true;
                                    $scope.assetHasCaptions = true;

                                    let source = '';

                                    if($scope.tenant.captioningServiceList.indexOf('WATSON') > -1) {
                                        source = 'ShareStream';
                                    }

                                    if($scope.tenant.captioningServiceList.indexOf('REV') > -1) {
                                        source = 'Rev';
                                    }

                                    $scope.captionsList.push({
                                        language: 'English',
                                        source: source,
                                        createdDate: new Date(),
                                        status: 'Processing',
                                        visibilityInPlayer: false,
                                        captionsRecentlyGenerated: false,
                                        captionsRecentlyProcessed: false
                                    });
                                }

                                if($scope.sentForCaptioningCs && !$scope.asset.receivedFromCaptioningCs){
                                    console.log("file was sent for captioning to captionsync - " + $scope.sentForCaptioningCs);
                                    console.log("Sent for captioning to captionsync.  Generating Captions...");
                                    $scope.tickedForCaptioning = true;
                                    $scope.assetHasCaptions = true;

                                    let source = '';

                                    $scope.captionsList.push({
                                        language: 'English',
                                        source: 'CaptionSync',
                                        createdDate: new Date(),
                                        status: 'Processing',
                                        visibilityInPlayer: false,
                                        captionsRecentlyGenerated: false,
                                        captionsRecentlyProcessed: false
                                    });
                                }

                            });

                            atmosphereSetup();
                        });
                    };

                    //Send for captioning
                    $scope.sendFileForCaptioning = function(assetId, toCaptionsync, turnAroundTime){
                        logger('sendFileForCaptioning')
                        $scope.subtitles = "[{'language': 'English','listOrder': 1, 'enabledByDefault': true}]";
                        console.log("Sent for captioning.  Generating Captions...");
                        $scope.getCaptionsForAsset();

                        if (toCaptionsync) { // send to captionsync
                            $scope.sentForCaptioningCs = true;
                            AssetService.SubmitToCaptionsync.get({aid: assetId, turnAroundTime: turnAroundTime});
                        }
                        else { // to watson
                            $scope.sentForCaptioning = true;
                            AssetService.GetAssetFilePath.get({aid: assetId, subtitles: $scope.subtitles});
                        }
                        $scope.sortDataTableBy($('#captionsDataTable table thead th:nth-child(4)')[0],'status', 'hideArrow');
                    };

                    $scope.getTranscript = function(assetId){
                        logger('getTranscript')
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: 'transcript',
                            language: ''
                        }, function (result) {

                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }

                        });
                    };

                    $scope.getChat = function(assetId){
                        logger('getChat')
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: 'chat'
                        }, function (result) {
                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }
                        });
                    };

                    getAsset();

                    // This is called whenever an asset is made favorite or not favorite
                    $scope.toggleFavorite = function (collectionId, assetId) {
                        logger('toggleFavorite')
                        var asset = this.asset,
                            isFavorite = asset.isFavorite;
                        AssetService.toggleAssetFavorite(this.asset, assetId, collectionId)
                            .then(function(response){
                                if(response.result){
                                    asset.isFavorite = !isFavorite;
                                }
                            }).catch(function() {
                                $log.error("An error occurred when trying to make asset favorite");
                            });
                    };

                    var removeHTMLTags = function(value) {
                        var processedText = value.replaceAll('<', '&lt;')
                        processedText = processedText.replaceAll('>', '&gt;')
                        return processedText;
                    }

                    // This is called whenever a comment needs to be added
                    $scope.addComment = function (commentText) {
                        logger('addComment')
                        var addComment = new AssetService.AddComment({
                            cid: collectionId,
                            aid: assetId,
                            text: removeHTMLTags(commentText)
                        });
                        addComment.$save(function (response) {
                            $scope.addCommentError = !response.result;
                            if (response.result) {
                                // Clear the form if submission is successful
                                $scope.addCommentForm.$setPristine();
                                $scope.commentText = "";
                                // Refresh the comments list
                                refreshComments();
                            }
                        });
                    };

                    // Logic for showing/hiding comment delete button
                    $scope.isDeletable = function () {
                        logger('isDeletable')
                        return (this.comment.author === $scope.account.login || this.comment.author === $scope.userFullName || $scope.asset.acl.indexOf("W") !== -1);
                    };

                    $scope.deleteComment = function (commentId) {
                        logger('deleteComment')
                        AssetService.DeleteComment.erase({
                            cid: collectionId,
                            aid: assetId,
                            commentId: commentId
                        }, function () {
                            refreshComments();
                        });
                    };

                    var refreshComments = function () {
                        logger('refreshComments')
                        AssetService.GetAsset.get({cid: collectionId, aid: assetId}, function (result) {
                            $scope.asset.totalComments = result.totalComments;
                        });
                        $scope.currentPage = 0;
                        AssetService.GetComments.query({
                            cid: collectionId,
                            aid: assetId,
                            offset: $scope.currentPage * $scope.commentsPerPage,
                            limit: $scope.commentsPerPage
                        }, function (comments) {
                            $scope.comments = $scope.mediaType === 'av' ? parseComments(comments) : comments;
                        });
                    };

                    $scope.loadMoreComments = function () {
                        logger('loadMoreComments')
                        $scope.currentPage++;
                        AssetService.GetComments.query({
                            cid: collectionId,
                            aid: assetId,
                            offset: $scope.currentPage * $scope.commentsPerPage,
                            limit: $scope.commentsPerPage
                        }, function (comments) {
                            $scope.comments = $scope.comments.concat($scope.mediaType === 'av' ? parseComments(comments) : comments);
                        });
                    };

                    /*
                     Seek to a particular position in the video/audio based on the time provided (time is a string here in hh:mm:ss or mm:ss format)
                     */
                    $scope.jumpPlaybackTo = function (time) {
                        logger('jumpPlaybackTo')

                        var parts = time.split(":"),
                            seconds = 0;

                        // convert the timestamp string into seconds since the Flowplayer seek API requires seek time to be in seconds
                        if (parts.length === 3) {
                            seconds = parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
                        } else if (parts.length === 2) {
                            seconds = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
                        }

                        // if the asset is an audio/video, use Flowplayer APIs to seek to a particular point in the asset.
                        if ($scope.mediaType === 'av') {
                            var elem = document.getElementById("player");
                            var api = flowplayer(elem);
                            if (api.ready) {
                                api.seek(seconds);
                                if (api.paused) {
                                    api.play();
                                }
                            } else {
                                api.load();
                                api.on('ready', function (e, api) {
                                    api.seek(seconds);
                                });
                            }
                            $('#player').focus();
                        }
                    };

                    $scope.download = function () {
                        logger('download')
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: $scope.asset.type
                        }, function (result) {

                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }

                        });
                        var recordPlayback = new AssetService.RecordPlayback({cid: $scope.asset.cid, aid: $scope.asset.aid, type: 'D'});
                        recordPlayback.$save();
                    };

                    // This is used to populate the embed code modal
                    $scope.showLink = function (collectionId, assetId) {
                        logger('showLink')
                        var showLink = new AssetService.ShowLink({cid: collectionId, aid: assetId});
                        showLink.$save(function (response) {
                            $scope.assetStreamableLink = response.streamableLink ? response.streamableLink : 'Not Available';
                            $scope.streamLinkPublic = response.isStreamableLinkPublic;
                            $scope.assetDownloadableLink = response.downloadableLink ? response.downloadableLink : 'Not Available';
                            $scope.downLinkPublic = response.isDownloadableLinkPublic;
                            $scope.assetEmbedCode = response.embedCode ? response.embedCode : 'Not Available';
                            $scope.sharedAssetCid = collectionId;
                            $scope.sharedAssetAid = assetId;
                            getAsset();
                        });
                    };

                    // This is used to populate the embed code modal
                    $scope.createHideLinkRequest = function (collectionId, assetId) {
                        logger('createHideLinkRequest')
                        $scope.hideLinkRequest = new AssetService.HideLink({cid: collectionId, aid: assetId});
                    };

                    $scope.hideLink = function () {
                        logger('hideLink')
                        $scope.hideLinkRequest.$save(function (response) {
                            if (response.result) {
                                getAsset();
                            }
                        });
                    };

                    $scope.sharePublicly = function (sharePublicSelected, linkType) {
                        logger('sharePublicly')
                        var toggleLinkStatus = new AssetService.ToggleLinkStatus({
                            cid: $scope.sharedAssetCid,
                            aid: $scope.sharedAssetAid,
                            isPublic: sharePublicSelected,
                            linkType: linkType
                        });
                        toggleLinkStatus.$save(function (response) {
                            if (linkType === 'S') {
                                $scope.assetStreamableLink = response.link;
                                $scope.assetEmbedCode = response.embedCode;
                                $scope.streamLinkPublic = sharePublicSelected;
                            } else if (linkType === 'D') {
                                $scope.assetDownloadableLink = response.link;
                                $scope.downLinkPublic = sharePublicSelected;
                            }
                        })
                    };

                    $scope.goBack = function (content) {
                        logger('goBack')
                        if ($scope.parent.type === 'course' || $scope.parent.type === 'collection' ||
                            $scope.parent.type === 'dropbox' || $scope.parent.type === 'assignment' ||
                            $scope.parent.type === 'zoom') {
                            if ($scope.hideHeaderAndFooter) {
                                $state.go('lmsCourse', {
                                    collectionId: ($scope.collectionTree && $scope.collectionTree.cid) || $scope.currentCollection.cid,
                                    items: [],
                                    type: '',
                                    showUnpublished: $scope.asset.isActive == 0,
                                    destinationFolderId: content.xid,
                                    destinationFolderCollectionTree: $scope.collectionTree
                                });
                            } else {
                                $state.go('course', {
                                    collectionId: ($scope.collectionTree && $scope.collectionTree.cid) || $scope.currentCollection.cid,
                                    items: [],
                                    type: '',
                                    showUnpublished: $scope.asset.isActive == 0,
                                    destinationFolderId: content.xid,
                                    destinationFolderCollectionTree: $scope.collectionTree
                                });
                            }
                        } else if ($scope.parent.type === 'channel') {
                            $state.go('channel', {
                                collectionId: ($scope.collectionTree && $scope.collectionTree.cid) || $scope.currentCollection.cid,
                                items: [],
                                type: '',
                                showUnpublished: $scope.asset.isActive == 0,
                                destinationFolderId: content.xid,
                                destinationFolderCollectionTree: $scope.collectionTree
                            });
                        } else if ($scope.parent.type === 'protected' || $scope.parent.type === 'reserves') {
                            $state.go('protected', {
                                collectionId: ($scope.collectionTree && $scope.collectionTree.cid) || $scope.currentCollection.cid,
                                items: [],
                                type: '',
                                showUnpublished: $scope.asset.isActive == 0,
                                destinationFolderId: content.xid,
                                destinationFolderCollectionTree: $scope.collectionTree
                            });
                        }
                    };

                    $scope.checkForEnterKey = function (event, action) {
                        logger('checkForEnterKey')
                        if (event.keyCode === 13) {
                            switch(action){
                                case "goBack":
                                    $scope.goBack();
                                    break;
                            }
                        }
                    };

                    $scope.openCaptionsModal = function(event) {
                        logger('openCaptionsModal')
                        $("#overwriteCaptionsModal").modal('show')
                            .on('shown.bs.modal', function () {
                                modalFocus('#publishHeading', '#returnTopublishHeading');
                                $('#returnTopublishHeading').on('focus', function () {
                                    $('#publishHeading').focus()
                                });
                            });
                    }
                    var modalFocus = function (first, last) {
                        logger('modalFocus')
                        var firstItem = $(first),
                            lastItem = $(last);

                        /*set focus on first item*/
                        firstItem.focus();

                        /*redirect last tab to first input*/
                        lastItem.on('keydown', function (e) {
                            if ((e.which === 9 && !e.shiftKey)) {
                                e.preventDefault();
                                firstItem.focus();
                            }
                        });

                        /*redirect first shift+tab to last input*/
                        firstItem.on('keydown', function (e) {
                            if ((e.which === 9 && e.shiftKey)) {
                                e.preventDefault();
                                lastItem.focus();
                            }
                        });
                    };

                    $scope.openTab = function(e, tabName) {
                        logger('openTab')
                        var i, tabcontent, tablinks;

                        //hide all tab contents
                        tabcontent = document.getElementsByClassName('tabcontent');
                        for (i = 0; i < tabcontent.length; i++) {
                            tabcontent[i].style.display = "none";
                        }

                        //make all tabs inactive
                        tablinks = document.getElementsByClassName('tablinks');
                        for (i = 0; i < tablinks.length; i++) {
                            tablinks[i].className = tablinks[i].className.replace(' active', '');
                        }

                        //opens the selected tab content and make it active
                        document.getElementById(tabName).style.display = 'block';

                        if(e) {
                            e.currentTarget.className += ' active';
                        } else {
                            tablinks[0].className += ' active';
                        }
                    }

                    $scope.showCaptionsForm = function(e) {
                        logger('showCaptionsForm');
                        $('#captionsEmptyState').hide();
                        $('#captionsForm').show();
                        $('.deleteCaptionsButton').hide();

                        //select English language
                        var searchInput = $('.languageSearch').find('input');
                        var defaultLanguage = 'english';
                        var selectedLanguage = languages.filter(p => p.title.toLowerCase() === defaultLanguage.toLowerCase());
                        $(searchInput).val(selectedLanguage[0].title);
                    }

                    $scope.handleCaptionsTabKeyPress = function(e) {
                        logger('handleCaptionsTabKeyPress')

                        if(e.key === 'Enter' || e.key === ' ') {
                            $scope.handleCaptionsTabClick(e);
                        }
                    }

                    $scope.handleCaptionsTabClick = function(e) {
                        logger('handleCaptionsTabClick')
                        e.preventDefault();
                        $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                        if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                            $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }else{
                            $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }
                        $('#coursetab_transcriptions').hide();
                        $('#coursetab_comments').hide();
                        $('#coursetab_transcriptions').hide();
                        $('#coursetab_description').hide();
                        $('#captionsForm').hide();
                        $('#coursetab_audioTracks').hide();
                        $('#audioTracksForm').hide();
                        $('#audioTracksDataTable').hide();
                        $('#audioTracksEmptyState').hide();
                        $('#coursetab_captions').show();
                        $scope.audioTrackMode = 'list';
                        resetAudioTrackUploadState();

                        if($scope.assetHasCaptions) {
                            $('#captionsDataTable').show();
                        } else {
                            $('#captionsEmptyState').css('display', 'flex');
                        }

                    }

                    $scope.handleAudioTracksTabKeyPress = function(e) {
                        logger('handleAudioTracksTabKeyPress')

                        if(e.key === 'Enter' || e.key === ' ') {
                            $scope.handleAudioTracksTabClick(e);
                        }
                    }

                    $scope.handleAudioTracksTabClick = function(e) {
                        logger('handleAudioTracksTabClick')
                        e.preventDefault();
                        $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                        if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                            $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }else{
                            $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }
                        $('#coursetab_transcriptions').hide();
                        $('#coursetab_comments').hide();
                        $('#coursetab_description').hide();
                        $('#coursetab_captions').hide();
                        $('#coursetab_audioTracks').show();
                        if($scope.audioTrackMode === 'form') {
                            $('#audioTracksForm').show();
                            $('#audioTracksDataTable').hide();
                            $('#audioTracksEmptyState').hide();
                        } else if($scope.assetHasAudioTracks) {
                            $('#audioTracksDataTable').show();
                            $('#audioTracksEmptyState').hide();
                            $('#audioTracksForm').hide();
                        } else {
                            $('#audioTracksEmptyState').css('display', 'block');
                            $('#audioTracksForm').hide();
                            $('#audioTracksDataTable').hide();
                        }

                        if($scope.audioTrackMode === 'form') {
                            attachAudioTrackFileInputListener();
                        }
                    }

                    $scope.handleDescriptionTabKeyPress = function(e) {
                        logger('handleDescriptionTabKeyPress')

                        if(e.key === 'Enter' || e.key === ' ') {
                            $scope.handleDescriptionTabClick(e);
                        }
                    }

                    $scope.handleDescriptionTabClick = function(e) {
                        logger('handleDescriptionTabClick');
                        e.preventDefault();
                        $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                        if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                            $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }else{
                            $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }
                        $('#captionsDataTable').hide();
                        $('#captionsEmptyState').hide();
                        $('#coursetab_transcriptions').hide();
                        $('#captionsForm').hide();
                        $('#coursetab_comments').hide();
                        $('#coursetab_description').show();
                        $('#coursetab_audioTracks').hide();
                        $('#audioTracksForm').hide();
                        $('#audioTracksDataTable').hide();
                        $('#audioTracksEmptyState').hide();
                        $scope.audioTrackMode = 'list';
                        resetAudioTrackUploadState();
                    }

                    $scope.handleCommentsTabKeyPress = function(e) {
                        logger('handleCommentsTabKeyPress')

                        if(e.key === 'Enter' || e.key === ' ') {
                            $scope.handleCommentsTabClick(e);
                        }
                    }

                    $scope.handleCommentsTabClick = function(e) {
                        logger('handleCommentsTabClick')
                        e.preventDefault();
                        $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                        if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                            $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }else{
                            $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }
                        $('#captionsDataTable').hide();
                        $('#captionsEmptyState').hide();
                        $('#coursetab_description').hide();
                        $('#coursetab_transcriptions').hide();
                        $('#captionsForm').hide();
                        $('#coursetab_comments').show();
                        $('#coursetab_audioTracks').hide();
                        $('#audioTracksForm').hide();
                        $('#audioTracksDataTable').hide();
                        $('#audioTracksEmptyState').hide();
                        $scope.audioTrackMode = 'list';
                        resetAudioTrackUploadState();
                    }

                    $scope.handleTranscriptionsTabKeyPress = function(e) {
                        logger('handleTranscriptionsTabKeyPress')

                        if(e.key === 'Enter' || e.key === ' ') {
                            $scope.handleTranscriptionsTabClick(e);
                        }
                    }

                    $scope.handleTranscriptionsTabClick = function(e) {
                        logger('handleTranscriptionsTabClick');
                        e.preventDefault();
                        $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                        if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                            $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }else{
                            $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                        }

                        $('#captionsForm').hide();
                        $('#captionsEmptyState').hide();
                        $('#captionsDataTable').hide();
                        $('#coursetab_description').hide();
                        $('#coursetab_comments').hide();
                        $('#coursetab_audioTracks').hide();
                        $('#audioTracksForm').hide();
                        $('#audioTracksDataTable').hide();
                        $('#audioTracksEmptyState').hide();
                        $scope.audioTrackMode = 'list';
                        resetAudioTrackUploadState();
                        $('#coursetab_transcriptions').show();
                        selectTranscriptionLanguage();
                    }

                    $scope.startAudioTrackUpload = function() {
                        logger('startAudioTrackUpload')
                        resetAudioTrackUploadState();
                        $scope.audioTrackMode = 'form';
                        attachAudioTrackFileInputListener();
                    }

                    $scope.cancelAudioTrackUpload = function() {
                        logger('cancelAudioTrackUpload')
                        resetAudioTrackUploadState();
                        $scope.audioTrackMode = 'list';
                    }

                    $scope.resetAudioTrackFileSelection = function() {
                        logger('resetAudioTrackFileSelection')
                        resetAudioTrackUploadState(true);
                    }

                    $scope.isAudioTrackUploadDisabled = function() {
                        return $scope.audioTrackUploading ||
                            !$scope.audioTrackUpload.file ||
                            !$scope.audioTrackUpload.type ||
                            $scope.audioTrackFileExtensionNotSupported;
                    }

                    $scope.handleAudioTrackUpload = function() {
                        logger('handleAudioTrackUpload')
                        if($scope.isAudioTrackUploadDisabled()) {
                            return;
                        }
                        $scope.audioTrackUploading = true;
                        $scope.audioTrackUploadError = null;

                        var fd = new FormData();
                        fd.append('file', $scope.audioTrackUpload.file);
                        var selectedLanguage = $scope.audioTrackUpload.language ? $scope.audioTrackUpload.language.title : '';
                        var selectedType = $scope.audioTrackUpload.type || defaultAudioTrackType;
                        var uploadUrl = 'api/asset/audiotrack?aid=' + assetId;
                        if(selectedLanguage) {
                            uploadUrl += '&language=' + encodeURIComponent(selectedLanguage);
                        }
                        if(selectedType) {
                            uploadUrl += '&type=' + encodeURIComponent(selectedType);
                        }

                        $http.post(uploadUrl, fd, {
                            transformRequest : angular.identity,
                            headers : {
                                'Content-Type' : undefined
                            }
                        }).then(function successCallback() {
                            $scope.audioTrackUploading = false;
                            $scope.audioTrackMode = 'list';
                            resetAudioTrackUploadState();
                            $scope.getAudioTracksForAsset(true);
                        }, function errorCallback() {
                            $scope.audioTrackUploading = false;
                            $scope.audioTrackUploadError = 'Unable to upload the audio track. Please try again.';
                        });
                    }

                    $scope.checkKeyDown = function (e) {
                        var tgt = e.currentTarget, flag = false;

                        switch (e.key) {
                            case 'ArrowLeft':
                              $scope.initializeTabs();
                              $scope.moveFocusToPreviousTab(tgt);
                              flag = true;
                              break;

                            case 'ArrowRight':
                              $scope.initializeTabs();
                              $scope.moveFocusToNextTab(tgt);
                              flag = true;
                              break;

                            case 'Home':
                              $scope.initializeTabs();
                              $scope.moveFocusToTab($scope.firstTab);
                              flag = true;
                              break;

                            case 'End':
                              $scope.initializeTabs();
                              $scope.moveFocusToTab($scope.lastTab);
                              flag = true;
                              break;

                            default:
                              break;
                        }

                        if (flag) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    };
                    $scope.moveFocusToTab = function(currentTab){
                        if (currentTab) {
                            if(typeof currentTab.focus === 'function'){
                                currentTab.focus();
                                //Include fallowing line for automatic tab selection
                                //currentTab.click();
                            }else{
                                console.log("moveFocusToTab() Element is not focusable.");
                            }
                        } else {
                            console.log("moveFocusToTab() Element to focus is not found.");
                        }
                    };
                    $scope.moveFocusToPreviousTab = function(currentTab){
                        var index;

                        if (currentTab === $scope.firstTab) {
                            $scope.moveFocusToTab($scope.lastTab);
                        } else {
                            index = $scope.tabs.indexOf(currentTab);
                            $scope.moveFocusToTab($scope.tabs[index - 1]);
                        }

                    };
                    $scope.moveFocusToNextTab = function(currentTab){
                        var index;

                        if (currentTab === $scope.lastTab) {
                            $scope.moveFocusToTab($scope.firstTab);
                        } else {
                            index = $scope.tabs.indexOf(currentTab);
                            $scope.moveFocusToTab($scope.tabs[index + 1]);
                        }
                    };
                    $scope.initializeTabs = function () {
                        $scope.tabs = Array.from($('.playback #navbarContent [role=tab]:visible'));
                        $scope.firstTab = null;
                        $scope.lastTab = null;
                        for (var i = 0; i < $scope.tabs.length; i++) {
                            if (!$scope.firstTab) {
                                $scope.firstTab = $scope.tabs[i];
                            }
                            $scope.lastTab = $scope.tabs[i];
                        }
                        if(!$scope.firstTab || !$scope.lastTab){
                            console.log("initializeTabs failed and are empty");
                        }else if(typeof $scope.firstTab.focus !== 'function' || typeof $scope.lastTab.focus !== 'function'){
                            console.log("initializeTabs failed and have no focus function");
                        }
                    };

                    var selectTranscriptionLanguage = function() {
                        $('#coursetab_transcriptions .languageValue').val('English');
                    }

                    $scope.handleDeleteErrorMessage = function() {
                        logger('handleDeleteErrorMessage')
                        $('.fileExtensionErrorMessage').hide();
                    }

                    $("#fileUpload").change(function(){
                        if($("#fileUpload").val().length) {
                             $scope.captionsList.push({
                                 id: -2,
                                 language: '',
                                 source: 'Manual Upload',
                                 status: 'Pending',
                                 createdDate: new Date(),
                                 visibilityInPlayer: true,
                                 captionsRecentlyGenerated: false,
                                 captionsRecentlyProcessed: true,
                             });
                             $scope.assetHasCaptions = true;
                             $scope.sortDataTableBy($('#captionsDataTable table thead th:nth-child(4)')[0],'status', 'hideArrow');
                             $('#captionsDataTable').show();
                             $('#captionsEmptyState').hide();
                             $scope.$apply();

                             var datatableIntervalId = setInterval(function() {
                                 if($('.datatable-recently-processed .languageValue').length) {
                                     clearInterval(datatableIntervalId);
                                     $('.datatable-recently-processed .languageValue').focus();
                                 }
                             }, 100);
                        }
                     });

                    $("#fileUpload1").change(function(){
                         $scope.captionsList.push({
                             id: -1,
                             language: '',
                             source: 'Manual Upload',
                             status: 'Pending',
                             createdDate: new Date(),
                             visibilityInPlayer: true,
                             captionsRecentlyGenerated: false,
                             captionsRecentlyProcessed: true,
                         });
                        $scope.sortDataTableBy($('#captionsDataTable table thead th:nth-child(4)')[0],'status', 'hideArrow');
                        $scope.$apply();

                        if($('.datatable-recently-processed .languageValue').length) {
                            $('.datatable-recently-processed .languageValue:nth-child(1)').focus();
                        }
                     });

                    $scope.handleCaptionUpload = function (language, file) {
                        logger('handleCaptionUpload')
                        var fd = new FormData();
                        $scope.captionsupdated = false;
                        fd.append("file", file);
                        $http.post('api/asset/caption?aid=' + assetId + "&language=" + language, fd, {
                            transformRequest : angular.identity,
                            headers : {
                                'Content-Type' : undefined
                            }
                        }).then(function successCallback(response) {
                                 document.getElementById("fileUpload1").value = null;
                                 $('#captionsForm').hide();
                                 $('#captionsDataTable').show();
                                 getAsset();
                                 setTimeout(() => {
                                     $scope.getCaptionsForAsset();
                                     $scope.captionsupdated = true;
                                 }, 2500);
                                  console.log('success: ', response);
                              }, function errorCallback(response) {
                                 console.log('error: ', response);
                          });
                    }

                    $scope.handleCaptionUpdate = function (assetAssociatedContent) {
                            logger('handleCaptionUpdate')
                            $scope.captionsupdated = false;
                            var updateItem = new BaseFileService.UpdateAssociatedContent(assetAssociatedContent);
                            updateItem.$save(
                                function (response) {
                                     document.getElementById("fileUpload1").value = null;
                                     $('#captionsForm').hide();
                                     $('#captionsDataTable').show();
                                     getAsset();
                                     setTimeout(() => {
                                         $scope.getCaptionsForAsset();
                                         $scope.captionsupdated = true;
                                         $($scope.savingCaptionElement).find('.searchFieldContainer')[0].focus();
                                     }, 2500);
                                      console.log('success: ', response);
                                },
                                function () {}
                            );
                    }

                    $scope.handleOrderCaptionsClickEmptyState = function(aid, toCaptionsync, turnAroundTime) {
                        logger('handleOrderCaptionsClickEmptyState')
                        $scope.sendFileForCaptioning(aid, toCaptionsync, turnAroundTime);
                        $('#captionsEmptyState').hide();
                        $('#captionsDataTable').removeClass('ng-hide');
                        $('#captionsDataTable').show();
                        $('.generate-captions-menu').hide();
                        $('.caption-sync-submenu').hide();
                        $('.generate-captions-button .arrow').css('transform', 'rotate(180deg)');

                        $scope.newCaptionState = true;
                    }

                    $scope.handleOrderCaptionsClick = function(aid, toCaptionsync, turnAroundTime) {
                        logger('handleOrderCaptionsClick')

                        var foundEnglishCaptions = false;
                        $('#captionsDataTable tbody .languageValue').each(function(index, item) {
                            if($(item).val() === 'English') {
                                if(toCaptionsync) {
                                    $scope.confirmGenerateAndOverwritePreexistingEnglishFileCs(turnAroundTime);
                                } else {
                                    $scope.confirmGenerateAndOverwritePreexistingEnglishFile();
                                }

                                foundEnglishCaptions = true;
                            }
                        });

                        if(!foundEnglishCaptions) {
                            $scope.sendFileForCaptioning(aid, toCaptionsync, turnAroundTime);
                        }
                    }

                    $scope.handleDataTableGenerateCaptionsButtonClick = function(e, aid, showCaptionsyncButton, isEmptyState) {
                        logger('handleDataTableGenerateCaptionsButtonClick')

                        if (!showCaptionsyncButton && isEmptyState) {
                            $scope.handleOrderCaptionsClickEmptyState(aid);
                        }
                        else if (!showCaptionsyncButton && !isEmptyState) {
                            //if English already exists, show modal to confirm overwrite
                            $('#captionsDataTable tbody .languageValue').each(function(index, item) {
                                if($(item).val() === 'English') {
                                    $scope.confirmGenerateAndOverwritePreexistingEnglishFile();
                                    return;
                                }
                            });

                            // if there is no overwrite conflict, proceed to generate the file
                            $scope.handleOrderCaptionsClick(aid);
                        }
                        else if (showCaptionsyncButton) { // if they have multiple caption providers, show the menu
                            var btnElement;
                            if(e.target.nodeName === 'BUTTON') {
                                btnElement = $(e.target);
                            } else {
                                btnElement = $(e.target).parent();
                            }

                            if(isEmptyState) {
                                $('.menu.generate-captions-menu.es').toggle();
                            }
                            else {
                                $('.menu.generate-captions-menu').toggle();
                            }

                            if ($(btnElement).children('.arrow').css('transform').indexOf('matrix') > -1) {
                                $(btnElement).children('.arrow').css('transform', '');
                            } else {
                                $(btnElement).children('.arrow').css('transform', 'rotate(180deg)');
                            }

                            if(isEmptyState) {
                                $('.menu.caption-sync-submenu.es').hide();
                            }
                            else {
                                $('.menu.caption-sync-submenu').hide();
                            }
                        }
                    }

                    $scope.activeLink = 'playback';
                    $scope.selectedFile = null;
                    $scope.loadComponent = function(component) {
                        $scope.activeLink = component;
                    }

                    var languages = [
                        {
                            id: 1,
                            title: 'English'
                        },
                        {
                            id: 2,
                            title: 'Abkhazian'
                        },
                        {
                            id: 3,
                            title: 'Afar'
                        },
                        {
                            id: 4,
                            title: 'Afrikaans'
                        },
                        {
                            id: 5,
                            title: 'Albanian'
                        },
                        {
                            id: 6,
                            title: 'Amharic'
                        },
                        {
                            id: 7,
                            title: 'Arabic'
                        },
                        {
                            id: 8,
                            title: 'Armenian'
                        },
                        {
                            id: 9,
                            title: 'Assamese'
                        },
                        {
                            id: 10,
                            title: 'Aymara'
                        },
                        {
                            id: 11,
                            title: 'Azerbaijani'
                        },
                        {
                            id: 12,
                            title: 'Bashkir'
                        },
                        {
                            id: 13,
                            title: 'Basque'
                        },
                        {
                            id: 14,
                            title: 'Bengali'
                        },
                        {
                            id: 15,
                            title: 'Bhutani'
                        },
                        {
                            id: 16,
                            title: 'Bihari'
                        },
                        {
                            id: 17,
                            title: 'Bislama'
                        },
                        {
                            id: 18,
                            title: 'Breton'
                        },
                        {
                            id: 19,
                            title: 'Bulgarian'
                        },
                        {
                            id: 20,
                            title: 'Burmese'
                        },
                        {
                            id: 21,
                            title: 'Byelorussian'
                        },
                        {
                            id: 22,
                            title: 'Cambodian'
                        },
                        {
                            id: 23,
                            title: 'Catalan'
                        },
                        {
                            id: 24,
                            title: 'Chinese'
                        },
                        {
                            id: 25,
                            title: 'Cornish'
                        },
                        {
                            id: 26,
                            title: 'Corsican'
                        },
                        {
                            id: 27,
                            title: 'Croatian'
                        },
                        {
                            id: 28,
                            title: 'Czech'
                        },
                        {
                            id: 29,
                            title: 'Danish'
                        },
                        {
                            id: 30,
                            title: 'Dutch'
                        },
                        {
                            id: 31,
                            title: 'Esperanto'
                        },
                        {
                            id: 32,
                            title: 'Estonian'
                        },
                        {
                            id: 33,
                            title: 'Faroese'
                        },
                        {
                            id: 34,
                            title: 'Fiji'
                        },
                        {
                            id: 35,
                            title: 'Finnish'
                        },
                        {
                            id: 36,
                            title: 'French'
                        },
                        {
                            id: 37,
                            title: 'Frisian'
                        },
                        {
                            id: 38,
                            title: 'Galician'
                        },
                        {
                            id: 39,
                            title: 'Georgian'
                        },
                        {
                            id: 40,
                            title: 'German'
                        },
                        {
                            id: 41,
                            title: 'Greek'
                        },
                        {
                            id: 42,
                            title: 'Greenlandic'
                        },
                        {
                            id: 43,
                            title: 'Guarani'
                        },
                        {
                            id: 44,
                            title: 'Gujarati'
                        },
                        {
                            id: 45,
                            title: 'Hausa'
                        },
                        {
                            id: 46,
                            title: 'Hebrew'
                        },
                        {
                            id: 47,
                            title: 'Hindi'
                        },
                        {
                            id: 48,
                            title: 'Hungarian'
                        },
                        {
                            id: 49,
                            title: 'Icelandic'
                        },
                        {
                            id: 50,
                            title: 'Indonesian'
                        },
                        {
                            id: 51,
                            title: 'Interlingua'
                        },
                        {
                            id: 52,
                            title: 'Interlingue'
                        },
                        {
                            id: 53,
                            title: 'Inuktitut'
                        },
                        {
                            id: 54,
                            title: 'Inupiak'
                        },
                        {
                            id: 55,
                            title: 'Irish'
                        },
                        {
                            id: 56,
                            title: 'Italian'
                        },
                        {
                            id: 57,
                            title: 'Japanese'
                        },
                        {
                            id: 58,
                            title: 'Javanese'
                        },

                        {
                            id: 59,
                            title: 'Kannada'
                        },
                        {
                            id: 60,
                            title: 'Kashmiri'
                        },
                        {
                            id: 61,
                            title: 'Kazakh'
                        },
                        {
                            id: 62,
                            title: 'Kinyarwanda'
                        },
                        {
                            id: 63,
                            title: 'Kirghiz'
                        },
                        {
                            id: 64,
                            title: 'Kirundi'
                        },
                        {
                            id: 65,
                            title: 'Korean'
                        },
                        {
                            id: 66,
                            title: 'Kurdish'
                        },
                        {
                            id: 67,
                            title: 'Laothian (Laotian)'
                        },
                        {
                            id: 68,
                            title: 'Latin'
                        },
                        {
                            id: 69,
                            title: 'Latvian; Lettish'
                        },
                        {
                            id: 70,
                            title: 'Lingala'
                        },
                        {
                            id: 71,
                            title: 'Lithuanian'
                        },
                        {
                            id: 72,
                            title: 'Luxemburgish'
                        },
                        {
                            id: 73,
                            title: 'Macedonian'
                        },
                        {
                            id: 74,
                            title: 'Malagasy'
                        },
                        {
                            id: 75,
                            title: 'Malay'
                        },
                        {
                            id: 76,
                            title: 'Malayalam'
                        },
                        {
                            id: 77,
                            title: 'Maltese'
                        },
                        {
                            id: 78,
                            title: 'Manx Gaelic'
                        },
                        {
                            id: 79,
                            title: 'Maori'
                        },
                        {
                            id: 80,
                            title: 'Marathi'
                        },
                        {
                            id: 81,
                            title: 'Moldavian'
                        },
                        {
                            id: 82,
                            title: 'Mongolian'
                        },
                        {
                            id: 83,
                            title: 'Nauru'
                        },
                        {
                            id: 84,
                            title: 'Nepali'
                        },
                        {
                            id: 85,
                            title: 'Northern Sámi'
                        },
                        {
                            id: 86,
                            title: 'Norwegian'
                        },
                        {
                            id: 87,
                            title: 'No: Bokmaal'
                        },
                        {
                            id: 88,
                            title: 'No: Nynorsk'
                        },
                        {
                            id: 89,
                            title: 'Occitan'
                        },
                        {
                            id: 90,
                            title: 'Oryia'
                        },
                        {
                            id: 91,
                            title: 'Oromo (Afan)'
                        },
                        {
                            id: 92,
                            title: 'Pashto; Pushto'
                        },
                        {
                            id: 93,
                            title: 'Persian'
                        },
                        {
                            id: 94,
                            title: 'Polish'
                        },
                        {
                            id: 95,
                            title: 'Portuguese'
                        },
                        {
                            id: 96,
                            title: 'Punjabi'
                        },
                        {
                            id: 97,
                            title: 'Quechua'
                        },
                        {
                            id: 98,
                            title: 'Rhaeto-Romance'
                        },
                        {
                            id: 99,
                            title: 'Romanian'
                        },
                        {
                            id: 100,
                            title: 'Russian'
                        },
                        {
                            id: 101,
                            title: 'Samoan'
                        },
                        {
                            id: 102,
                            title: 'Sangho'
                        },
                        {
                            id: 103,
                            title: 'Sanskrit'
                        },
                        {
                            id: 104,
                            title: 'Scots Gaelic'
                        },
                        {
                            id: 105,
                            title: 'Serbian'
                        },
                        {
                            id: 106,
                            title: 'Serbo-Croatian'
                        },
                        {
                            id: 107,
                            title: 'Sesoto'
                        },
                        {
                            id: 108,
                            title: 'Setswana'
                        },
                        {
                            id: 109,
                            title: 'Shona'
                        },
                        {
                            id: 110,
                            title: 'Sindhi'
                        },
                        {
                            id: 111,
                            title: 'Singhalese'
                        },
                        {
                            id: 112,
                            title: 'Siswati'
                        },
                        {
                            id: 113,
                            title: 'Slovak'
                        },
                        {
                            id: 114,
                            title: 'Slovenian'
                        },
                        {
                            id: 115,
                            title: 'Somali'
                        },
                        {
                            id: 116,
                            title: 'Spanish'
                        },
                        {
                            id: 117,
                            title: 'Sudanese'
                        },
                        {
                            id: 118,
                            title: 'Swedish'
                        },
                        {
                            id: 119,
                            title: 'Swahili'
                        },
                        {
                            id: 120,
                            title: 'Tagalog'
                        },
                        {
                            id: 121,
                            title: 'Tajik'
                        },
                        {
                            id: 122,
                            title: 'Tamil'
                        },
                        {
                            id: 123,
                            title: 'Tatar'
                        },
                        {
                            id: 124,
                            title: 'Telugu'
                        },
                        {
                            id: 125,
                            title: 'Thai'
                        },
                        {
                            id: 126,
                            title: 'Tibetan'
                        },
                        {
                            id: 127,
                            title: 'Tigrinya'
                        },
                        {
                            id: 128,
                            title: 'Tonga'
                        },
                        {
                            id: 129,
                            title: 'Tsonga'
                        },
                        {
                            id: 130,
                            title: 'Turkish'
                        },
                        {
                            id: 131,
                            title: 'Turkmen'
                        },
                        {
                            id: 132,
                            title: 'Twi'
                        },
                        {
                            id: 133,
                            title: 'Uigur'
                        },
                        {
                            id: 134,
                            title: 'Ukrainian'
                        },
                        {
                            id: 135,
                            title: 'Urdu'
                        },
                        {
                            id: 136,
                            title: 'Uzbek'
                        },
                        {
                            id: 137,
                            title: 'Vietnamese'
                        },
                        {
                            id: 138,
                            title: 'Volapük'
                        },
                        {
                            id: 139,
                            title: 'Welsh'
                        },
                        {
                            id: 140,
                            title: 'Wolof'
                        },
                        {
                            id: 141,
                            title: 'Xhosa'
                        },
                        {
                            id: 142,
                            title: 'Yddish'
                        },
                        {
                            id: 143,
                            title: 'Yoruba'
                        },
                        {
                            id: 144,
                            title: 'Zhuang'
                        },
                        {
                            id: 145,
                            title: 'Zulu'
                        },
                    ];

                    $scope.languages = languages;
                    defaultAudioTrackLanguage = languages.find(function(language) {
                        return language.title && language.title.toLowerCase() === 'english';
                    }) || languages[0] || null;
                    setDefaultAudioTrackLanguage();
                    setDefaultAudioTrackType();

                    $scope.handleSearchInputKeyDown = function(e) {
                        logger('handleSearchInputKeyDown')

                        if(
                            (e.key === 'ArrowLeft' || e.key === 'ArrowRight') &&
                            languages.filter(p => p.title === $(e.target).val()).length
                        ) {
                            return;
                        }

                        if(e.key === 'ArrowDown') {
                            e.stopPropagation();
                            e.preventDefault();

                            if( $(e.target).val().length < 3 ){
                                //show all options
                                $scope.filteredLanguages = languages;
                                setTimeout(function(){
                                    $scope.$apply();
                                }, 0)

                                $(e.target).parents('.searchFieldContainer').find('.languageSearchResults').show();
                                $(e.target).parents('.searchFieldContainer').find('.languageSearchResults li:first-child').focus();
                            } else {
                                if( $(e.target).parents('.searchFieldContainer').find('.languageSearchResults').is(':visible') ) {
                                    $(e.target).parents('.searchFieldContainer').find('.languageSearchResults li:first-child').focus();
                                }
                            }

                            return;
                        }

                        if(e.key === 'ArrowUp') {
                            if($(e.target).parents('.searchFieldContainer').find('.languageNoResults').is(':visible')) {
                                e.preventDefault();
                                return;
                            }
                        }

                        //If there's a language selected and the user starts typing something
                        var foundLanguage = languages.filter(p => p.title === e.target.value.trim());

                        //If Space pressed
                        if(e.keyCode === 32) {
                            //If there's a language selected, we start typing from the beginning
                            //without cleaning the field, to avoid displaying the placeholder text momentarily
                            if(foundLanguage.length) {
                                e.target.value = ' ';
                            } else {
                                e.target.value += ' ';
                            }
                        }

                        //New text will replace the previously selected language
                        if(e.keyCode !== 9) {
                            if(foundLanguage.length && e.target.selectionStart === 0) {
                                e.target.value = '';
                            }
                        }
                    }

                    $scope.hideLanguageSearchResults = function (element) {
                        $(element).parents('.languageSearch').find('.languageSearchResults').hide();
                        rotateCaretIcon($(element).parents('searchFieldContainer').find('.caretIconButton img'));
                    }

                    $scope.hideLanguageNoResults = function (element) {
                        $(element).parents('.languageSearch').find('.languageNoResults').hide();
                        rotateCaretIcon($(element).parents('searchFieldContainer').find('.caretIconButton img'));
                    }

                    $scope.handleSearchInputKeyUp = function (e) {
                        logger('handleSearchInputKeyUp');

                        if(e.keyCode === 27) {
                            $scope.hideLanguageNoResults($(e.target));
                            $scope.hideLanguageSearchResults($(e.target));
                            $(e.target).parents('.languageSearch').find('input.languageValue').val('');
                            $(e.target).parents('.languageSearch').find('.clearButton').hide();
                            return;
                        }

                        if(e.target.value.length > 2) {
                            var searchText = e.target.value;
                            $scope.filteredLanguages = languages.filter(p => p.title.toLowerCase().startsWith(searchText.toLowerCase()));
                            $(e.target).parents('.languageSearch').find('.languageSearchResults').show();
                            rotateCaretIcon($(e.target).parents('.searchFieldContainer').find('.caretIconButton img'));
                            scrollTableToShowResults(e.target);
                        } else {
                            $scope.filteredLanguages = languages;
                        }

                        if(e.target.value.length) {
                            $(e.target).parent().parent().find('.clearButton').show();
                            $(e.target).parent().parent().find('.caretIconButton').hide();
                        } else {
                            $(e.target).parent().parent().find('.clearButton').hide();
                            $(e.target).parent().parent().find('.caretIconButton').show();
                        }

                        showDownCaretIcon($(e.target).parent().parent().find('.caretIcon'));

                        if($scope.filteredLanguages.length) {
                            $(e.target).parents('.languageSearch').find('.languageNoResults').hide();
                        } else {
                            $(e.target).parents('.languageSearch').find('.languageNoResults').show();
                        }

                    }

                    $scope.hideAllLanguageSearchResults = function() {
                        $('.languageSearchResults').hide();
                    }

                    $scope.handleResultClick = function(e, caption, language) {
                        logger('handleResultClick');

                        avoidErrorForLanguageSelect = true;
                        setTimeout(function(){
                            avoidErrorForLanguageSelect = false;
                        }, 1000)

                        var currentRow = $(e.target).parents('tr')[0];
                        var currentRowIndex;
                        var negativeIds = 0;

                        $(currentRow).removeClass('datatable-recently-processed');
                        $(e.target).parents('tbody').find('tr').each(function(index, item){
                            if($(item).find('.languageValue').attr('data-caption-id') < 0) {
                                negativeIds++;
                            }
                            if( $(item)[0] === currentRow ) {
                                currentRowIndex = index;
                            }
                        });

                        currentRowIndex -= negativeIds;

                        //This avoids calling the api to update to the same language
                        if(currentRowIndex > -1 && $scope.captionsList[currentRowIndex].language === $(e.target).text().trim() ) {
                            $(e.target).parents('.searchFieldContainer').find('.languageValue').val($scope.captionsList[currentRowIndex].language);
                            return;
                        }

                        var previousCaptionId = $(e.target).parents('.searchFieldContainer').find('input.languageValue').attr('data-caption-id');
                        var previousCaption = $scope.captionsList.find(p => p.id.toString() === previousCaptionId.toString());
                        $scope.updatingCaption = JSON.parse(JSON.stringify(previousCaption));

                        $scope.selectedLanguageEvent = e;
                        var searchInput = $(e.target).parents('.languageSearch').find('input');

                        var listItemElement;
                        if(e.target.nodeName === 'LI') {
                            listItemElement = $(e.target);
                        } else if(e.target.nodeName === 'DIV') {
                            listItemElement = $(e.target).parent();
                        }

                        var languageId = $(listItemElement).attr('data-language-id');

                        setTimeout(() => {
                            $(listItemElement).parents('.languageSearch').find('input.languageValue').css('background', '');
                            $(listItemElement).parents('.languageSearch').find('.searchFieldContainer').css('background', '');
                        }, 0)
                        var associatedContentId = parseInt($($($(listItemElement).parents('td')[0]).siblings()[0]).text());
                        $scope.assetAssociatedContent = $scope.captionsList.filter(x => x.id == associatedContentId)[0];
                        var selectedLanguage = languages.filter(p => p.id.toString() === languageId.toString());
                        var languageName = selectedLanguage[0].title;

                        $scope.hideAllLanguageSearchResults();
                        $(searchInput).val(languageName);
                        console.log('associatedContentId: ', associatedContentId);

                        //check if selected language exists in datatable
                        var languageAlreadyExists = false;
                        var languageEntries = 0;
                        $('#captionsDataTable tbody .languageValue').each(function(index, item) {
                            if($(item).val() === languageName) {
                                languageEntries++;
                            }
                        });

                        if (languageEntries > 1) {
                            languageAlreadyExists = true;
                        }

                        if (languageAlreadyExists) {
                            //show confirm modal
                            caption.language = language.title;
                            if(document.getElementById("fileUpload1").files.length === 1) {
                            //user uploading a new captions file and selected an existing language
                                $scope.confirmOverwriteCaption(caption);
                            }
                            else if(document.getElementById("fileUpload1").files.length === 0) {
                            //user updating the language of an existing captions file to an existing language
                                $scope.confirmOverwritePreexistingCaptionsFile(caption);
                            }

                        } else {
                            $scope.savingCaptionElement = $(e.target).parents('tr');
                            $scope.saveCaption({associatedContentId, languageName, event: e});
                        }

                        $('.caretIconButton').show();
                    }

                    $scope.saveCaption = function(params) {
                        logger('saveCaption')

                        if (params.language && params.language.title) {
                            params.languageName = params.language.title;
                        } else if (params.language) {
                            params.languageName = params.language;
                        }

                        if(!params.associatedContentId) {
                            params.associatedContentId = params.id;
                        }

                        if (params.associatedContentId == -1) {
                            // create
                            $scope.handleCaptionUpload(params.languageName, document.getElementById("fileUpload1").files[0]);
                        }
                        else if (params.associatedContentId == -2) {
                            // create
                            $scope.handleCaptionUpload(params.languageName, document.getElementById("fileUpload").files[0]);
                        }
                        else {
                            // update
                            var updatedLanguage = params.language && params.language.title ? params.language.title : params.languageName;
                            $scope.assetAssociatedContent.language = updatedLanguage;
                            $scope.assetAssociatedContent.title = updatedLanguage;
                            $scope.handleCaptionUpdate($scope.assetAssociatedContent);
                        }

                        $scope.captionsErrorState[params.associatedContentId] = false;
                        rotateCaretIcon($($scope.selectedLanguageEvent.target).parents('.languageSearch').find('.caretIcon'));
                    }

                    $scope.captionsErrorState = new Map();

                    var clearButtonClicked = false;
                    $scope.handleSearchClearClick = function(e, captionId) {
                        logger('handleSearchClearClick');
                        e.stopPropagation();
                        e.preventDefault();
                        $scope.filteredLanguages = languages;

                        $(e.target).parents('.clearButton').hide();
                        $(e.target).parents('.datatableRow').find('.caretIconButton').show();

                        clearButtonClicked = true;
                        var searchInput = $(e.target).parents('.languageSearch').find('input');
                        $scope.hideLanguageNoResults($(e.target));
                        $scope.hideLanguageSearchResults($(e.target));

                        showDownCaretIcon($(e.target).parents('.languageSearch').find('.caretIcon'));

                        $(searchInput).val('');
                        $scope.captionsErrorState[captionId] = false;

                        $(e.target).parents('.datatableRow').find('.status').removeClass('published');
                        $(e.target).parents('.datatableRow').find('.status').removeClass('error');
                        $(e.target).parents('.datatableRow').find('.status').addClass('pending');
                        $(e.target).parents('.datatableRow').addClass('datatable-recently-processed');

                        $(searchInput).focus();
                    }

                    $scope.handleSearchCaretClick = function (e) {
                        logger('handleSearchCaretClick');

                        avoidErrorForLanguageSelect = true;
                        setTimeout(function(){
                            avoidErrorForLanguageSelect = false;
                        }, 1000)

                        e.stopPropagation();

                        $scope.filteredLanguages = languages;
                        var caretElement = $(e.target).find('img');

                        if(e.target.nodeName === 'BUTTON') {
                            caretElement = $(e.target).find('img');
                        } else if (e.target.nodeName === 'IMG') {
                            caretElement = $(e.target);
                        }

                        //reset all other carets to original down position
                        $('.caretIcon').each(function(index, item) {
                            if($(item)[0] !== $(caretElement)[0]) {
                                showDownCaretIcon($(item));
                            }
                        })

                        rotateCaretIcon(caretElement);

                        var inputElement = $(e.target).parents('.searchFieldContainer').find('input.languageValue');
                        inputElement.focus();
                        inputElement[0].setSelectionRange(0, 0);

                        $('.languageSearchResults').hide();
                        var resultsElement =  $(e.target).parents('.searchFieldContainer').find('.languageSearchResults');
                        $(resultsElement).toggle();

                        $scope.previousLanguageId = $(e.target).parents('.searchFieldContainer').find('.languageValue').attr('data-language-id');

                        setTimeout(() => {
                            scrollTableToShowResults(e.target);
                        }, 50);
                    }

                    var scrollTableToShowResults = function (element) {
                        logger('scrollTableToShowResults')
                        var targetTop = $(element).offset().top;
                        var scrollPos = $(element).parents('table').parent().scrollTop();
                        var tablePos = $(element).parents('table').parent().offset().top;
                        var newPos = targetTop - tablePos + scrollPos;

                        $(element).parents('table').parent().scrollTop(newPos - 20);
                    }
                    var rotateCaretIcon = function (caretIconElement) {
                        logger('rotateCaretIcon')
                        if($(caretIconElement).css('transform') === 'matrix(1.3, 0, 0, 1.3, 0, 0)') {
                            $(caretIconElement).css({'transform': 'rotate(180deg) scale(1.3)', });
                        } else {
                            $(caretIconElement).css('transform', 'rotate(0deg) scale(1.3)');
                        }
                    }
                    var showDownCaretIcon = function(caretIconElement) {
                        logger('showDownCaretIcon')
                        $(caretIconElement).css('transform', 'rotate(0deg) scale(1.3)');
                    }

                    var showUpCaretIcon = function(caretIconElement) {
                        logger('showUpCaretIcon')
                        $(caretIconElement).css('transform', 'rotate(180deg) scale(1.3)');
                    }

                    $scope.handleSearchInputFocus = function(e) {
                        logger('handleSearchInputFocus');
                        e.preventDefault();
                        if(!clearButtonClicked) {
                            $scope.filteredLanguages = languages;

                            $('.clearButton').hide();

                            if(e.target.value.length) {
                                $(e.target).parents('.languageSearch').find('.clearButton').show();
                            } else {
                                $(e.target).parents('.languageSearch').find('.clearButton').hide();
                            }

                            $('.searchFieldContainer').css('background', '');
                            $('input.languageValue').css('background', '');

                            setTimeout(() => {
                                $(e.target).css('background', '#FFFFFF');
                                $(e.target).parents('.searchFieldContainer').css('background', '#FFFFFF');
                            }, 50);
                        }

                        clearButtonClicked = false;
                    }

                    $scope.handleCheckAllCaptionsClick = function(e) {
                        logger('handleCheckAllCaptionsClick')
                        document.querySelectorAll('.captionCheckbox').forEach(item => {
                           item.checked = e.target.checked;
                        })
                    }



                    $scope.deleteCaptionsFile = function(){
                        logger('deleteCaptionsFile')
                        //delete file
                        $('#captionsForm').find('input[type="file"]').val('');
                        $('#captionsForm').find('input[type="file"]').removeAttr('disabled');

                        //hide delete button
                        $('.deleteCaptionsButton').hide();

                        //hide error message
                        $('.fileExtensionErrorMessage').hide();

                        //enable upload button
                        $('.uploadCaptionsButton').attr('disabled', true);
                    }

                    var tries = 0;
                    var intervalId = setInterval(function() {
                        tries++;
                        if($('#captionsForm').find('input[type="file"]').length) {
                            $('#captionsForm').find('input[type="file"]').change(function(){

                                if($('#captionsForm').find('input[type="file"]').val() !== '') {
                                    if(fileNameContainsInvalidExtension($('#captionsForm').find('input[type="file"]').val())) {
                                        $scope.fileExtensionNotSupported = true;
                                        $('.fileExtensionErrorMessage').css('display', 'flex');
                                        $('.uploadCaptionsButton').attr('disabled', true);
                                    } else {
                                        $('.fileExtensionErrorMessage').hide();
                                        $scope.fileExtensionNotSupported = false;
                                        $('.uploadCaptionsButton').removeAttr('disabled');
                                    }

                                    $('.deleteCaptionsButton').show();
                                    $('#captionsForm').find('input[type="file"]').attr('disabled', true)
                                }
                            })

                            clearInterval(intervalId);
                        }
                    }, 500);

                    var fileNameContainsInvalidExtension = function(filePath) {
                        logger('fileNameContainsInvalidExtension')
                        var extension;

                        for(var i = filePath.length - 1; i >= 0; i--) {
                            if(filePath.charAt(i) === '.') {
                                extension = filePath.substring(i);
                                break;
                            }
                        }

                        if(extension.toLowerCase() !== '.srt' && extension.toLowerCase() !== '.vtt') {
                            return true;
                        }

                        return false;
                    }

                    $scope.handleCancelButtonClick = function() {
                        logger('handleCancelButtonClick');
                        $('#captionsForm').hide();

                        if($scope.assetHasCaptions) {
                            $('#captionsDataTable').removeClass('ng-hide');
                            $('#captionsDataTable').show();
                        } else {
                            $('#captionsEmptyState').removeClass('ng-hide');
                            $('#captionsEmptyState').show();
                        }
                    }

                    $scope.hideErrorMessage = function() {
                        logger('hideErrorMessage')
                        $('.fileExtensionErrorMessage').hide();
                    }

                    var statusOrder = [
                        {order: 1, status: 'Pending'},
                        {order: 2, status: 'Error'},
                        {order: 3, status: 'Processing'},
                        {order: 4, status: 'Published'},
                    ];

                    var sortDirectionsDesc = {
                        'dateCreated' : false,
                        'language' : false,
                        'source' : false,
                        'status' : false,
                    };

                    $scope.sortDataTableBy = function(el, column, action) {
                        logger('sortDataTableBy')

                        let sortDirectionDesc = sortDirectionsDesc[column];
                        sortDirectionDesc = !sortDirectionDesc;
                        sortDirectionsDesc[column] = sortDirectionDesc;

                        //arrow direction
                        if(sortDirectionDesc) {
                            ($(el).parent().find('img').css('transform', 'rotate(0deg)'));
                        } else {
                            ($(el).parent().find('img').css('transform', 'rotate(180deg)'));
                        }

                        //gray to other titles
                        $(el).parent().parent().find('span').css('color', '#5C6778');

                        //selected color to current title
                        if(el.nodeName === 'SPAN') {
                            $(el).css('color', '#404852');
                        } else if(el.nodeName === 'IMG'){
                            $(el).parent().children('span').css('color', '#404852');
                        }

                        //hide other arrows
                        $(el).parent().parent().find('img').css('opacity', 0);

                        //show current arrow
                        if(action !== 'hideArrow') {
                            $(el).parent().find('img').css('opacity', 1);
                        }

                        if(column === 'dateCreated') {
                            //sort table by date added
                            if(sortDirectionDesc) {
                                $scope.captionsList.sort((a, b) => a.createdDate < b.createdDate ? 1 : -1);
                            } else {
                                $scope.captionsList.sort((a, b) => a.createdDate > b.createdDate ? 1 : -1);
                            }
                        }

                        if(column === 'language') {
                            //sort table by language
                            if(sortDirectionDesc) {
                                $scope.captionsList.sort((a, b) => a.language < b.language ? 1 : -1);
                            } else {
                                $scope.captionsList.sort((a, b) => a.language > b.language ? 1 : -1);
                            }
                        }

                        if(column === 'source') {
                            //sort table by source
                            if(sortDirectionDesc) {
                                $scope.captionsList.sort((a, b) => a.source < b.source ? 1 : -1);
                            } else {
                                $scope.captionsList.sort((a, b) => a.source > b.source ? 1 : -1);
                            }
                        }

                        if(column === 'status') {
                            //sort table by status following the specified order in the statusOrder array
                            if(action === 'hideArrow') {
                                $scope.captionsList.sort((a, b) => statusOrder.find(p => p.status === a.status).order > statusOrder.find(p => p.status === b.status).order ? 1 : -1);
                            } else {
                                if(sortDirectionDesc) {
                                    $scope.captionsList.sort((a, b) => statusOrder.find(p => p.status === a.status).order < statusOrder.find(p => p.status === b.status).order ? 1 : -1);
                                } else {
                                    $scope.captionsList.sort((a, b) => statusOrder.find(p => p.status === a.status).order > statusOrder.find(p => p.status === b.status).order ? 1 : -1);
                                }
                            }
                        }
                    }

                    $scope.newCaptionState = false;

                    $scope.getTodayDate = function(caption) {
                        console.log('getTodayDate')
                        return moment(caption.createdDate).format("MMM. DD, YYYY")
                    }

                    $scope.formatDate = function (dateParam) {
                        // logger('formatDate', dateParam)
                        var date = new Date(dateParam);
                        var month = date.getMonth();
                        var monthName = months.find(p => p.number === month + 1);
                        var day = date.getDate();
                        var year = date.getFullYear();

                        return monthName.name + ' ' + day + ', ' + year;
                    }

                    $scope.handleFormUploadButtonClick = function (e) {
                        logger('handleFormUploadButtonClick')
                        //if there's already a caption in the same language, ask for confirmation
                        var language = $('#captionsForm input.languageValue').val();
                        var check = $scope.captionsList.find(p => p.language === language);

                        if(check) {
                            $scope.openCaptionsModal();
                        } else {
                            $scope.handleCaptionUpload();
                            $scope.getCaptionsForAsset();
                            $('#captionsDataTable').show();
                        }
                    }

                    $scope.handleCloseModalButtonClick = function (e) {
                        logger('handleCloseModalButtonClick')
                        $(e.target).parents('#overwriteCaptionsModal').hide();
                    }

                    $scope.handleCloseModalButtonKeyUp = function (e) {
                        logger('handleCloseModalButtonKeyUp')
                        if(e.keyCode === 13) {
                            // $(e.target).parents('#overwriteCaptionsModal').hide();
                            $scope.handleCloseModalButtonClick(e);
                        }
                    }

                    $scope.openShareModal = function() {
                        logger('openShareModal')
                        //fill the start at field
                        var startAt = $('.fp-elapsed').text();

                        if(startAt) {
                            $('input.timestamp').val(startAt);
                        }

                        //clear any previous timestamp set
                        var questionMarkPosition = $('input.sharelink').val().indexOf('?');
                        if(questionMarkPosition > -1) {
                            $('input.sharelink').val(
                                $('input.sharelink').val().substring(0, questionMarkPosition)
                            );
                        }

                        //add the timestamp to the url
                        $('input.sharelink').val(
                            $('input.sharelink').val() + '?t=' + startAt
                        );

                        //show modal
                        $("#shareModal").modal('show')
                            .on('shown.bs.modal', function () {
                                modalFocus('#publishHeading', '#returnTopublishHeading');
                                $('#returnTopublishHeading').on('focus', function () {
                                    $('#publishHeading').focus()
                                });
                            });
                    }

                    $scope.handleStartAtCheckboxClick = function (e) {
                        logger('handleStartAtCheckboxClick')
                        if(e.target.checked && $('input.timestamp').val().length) {
                            $('input.sharelink').val(
                                $('input.sharelink').val() + '?t=' + $('input.timestamp').val()
                            )
                        } else {
                            var questionMarkPosition = $('input.sharelink').val().indexOf('?');
                            if(questionMarkPosition > -1) {
                                $('input.sharelink').val(
                                    $('input.sharelink').val().substring(0, questionMarkPosition)
                                )
                            }
                        }
                    }

                    var months = [{
                        number: 1, name: 'Jan.'
                    },
                        {
                            number: 2, name: 'Feb.'
                        },
                        {
                            number: 3, name: 'Mar.'
                        },
                        {
                            number: 4, name: 'Apr.'
                        },
                        {
                            number: 5, name: 'May'
                        },
                        {
                            number: 6, name: 'June'
                        },
                        {
                            number: 7, name: 'July'
                        },
                        {
                            number: 8, name: 'Aug.'
                        },
                        {
                            number: 9, name: 'Sept.'
                        },
                        {
                            number: 10, name: 'Oct.'
                        },
                        {
                            number: 11, name: 'Nov.'
                        },
                        {
                            number: 12, name: 'Dec.'
                        }
                    ];

                    $scope.toggleFullDescription = function () {
                        logger('toggleFullDescription')
                        $scope.parent.descriptionExpanded = !$scope.parent.descriptionExpanded;
                    }

                    $scope.handleModalShareToggleClick = function(e) {
                        logger('handleModalShareToggleClick')
                        if(e.target.checked) {
                            setTimeout(() => {
                                $('#shareModal .modal-title span').text('Share Media Asset');
                                $('#shareModal .modal-supporting-text').text('');
                                $('#shareModal .modal-supporting-text').hide('');
                                $('.shareControls').show();

                                $('input.timestamp').parent().find('input.item-checkbox').addClass('custom-checkbox');
                                $('input.timestamp').parent().find('input.item-checkbox').removeClass('custom-checkbox-disabled');
                                $('input.timestamp').prop('disabled', false);
                                $('input.sharelink').prop('disabled', false);
                                $('button.copyLink').prop('disabled', false);
                                $('div.embedCode').css('background', '#FFFFFF');
                                $('button.copyEmebedCode').prop('disabled', false);
                            }, 200);
                        } else {
                            setTimeout(() => {
                                $('#shareModal .modal-title span').text('Disable Sharing For This Media Asset?');
                                $('#shareModal .modal-supporting-text').text('Disabling sharing for this Media Asset will be….');
                                $('#shareModal .modal-supporting-text').show();
                                $('.shareControls').hide();

                                $('input.timestamp').parent().find('input.item-checkbox').removeClass('custom-checkbox');
                                $('input.timestamp').parent().find('input.item-checkbox').addClass('custom-checkbox-disabled');
                                $('input.timestamp').prop('disabled', true);
                                $('input.sharelink').prop('disabled', true);
                                $('button.copyLink').prop('disabled', true);
                                $('div.embedCode').css('background', '#EFEFEF4D');
                                $('button.copyEmebedCode').prop('disabled', true);
                            }, 200);
                        }
                    }

                    $scope.getAudioTracksForAsset = function(shouldReloadPlayer){
                        logger('getAudioTracksForAsset')
                        AssetService.GetAssetAudioTracks.get({aid: assetId}, function (result) {
                            var contents = (result && result.contents) ? result.contents : [];
                            $scope.audioTracksList = contents;
                            $scope.assetHasAudioTracks = contents.length > 0;
                            if(!$scope.assetHasAudioTracks && $scope.audioTrackMode !== 'form') {
                                $scope.audioTrackMode = 'list';
                            }
                            if(shouldReloadPlayer) {
                                reloadPlayerAfterAudioTrackChange();
                            }
                        }, function () {
                            $scope.audioTracksList = [];
                            $scope.assetHasAudioTracks = false;
                            if($scope.audioTrackMode !== 'form') {
                                $scope.audioTrackMode = 'list';
                            }
                            if(shouldReloadPlayer) {
                                reloadPlayerAfterAudioTrackChange();
                            }
                        });
                    };

                    $scope.getCaptionsForAsset = function(shouldShowRecentlyGeneratedCaptions){
                        logger('getCaptionsForAsset')
                        AssetService.GetAssetCaptions.get({aid: assetId}, function (result) {
                            $scope.deleteCaptionsFile();
                            $scope.captionsList = result.contents;

                            $scope.assetHasCaptions = result.totalContents > 0;
                            if ($scope.assetHasCaptions) {
                                $('#captionsEmptyState').css('display', 'flex');
                            }

                            if ($scope.sentForCaptioning && !shouldShowRecentlyGeneratedCaptions && !$scope.receivedFromCaptioning) {
                                let source = '';

                                if($scope.tenant.captioningServiceList.indexOf('WATSON') > -1) {
                                    source = 'ShareStream';
                                }

                                if($scope.tenant.captioningServiceList.indexOf('REV') > -1) {
                                    source = 'Rev';
                                }

                                $scope.captionsList.push({
                                    language: 'English',
                                    source: source,
                                    createdDate: new Date(),
                                    status: 'Processing',
                                    visibilityInPlayer: false,
                                    captionsRecentlyGenerated: false,
                                    captionsRecentlyProcessed: false
                                });
                                $scope.assetHasCaptions = true;
                            }

                            if ($scope.sentForCaptioningCs && !shouldShowRecentlyGeneratedCaptions && !$scope.asset.receivedFromCaptioningCs) {
                                $scope.captionsList.push({
                                    language: 'English',
                                    source: 'CaptionSync',
                                    createdDate: new Date(),
                                    status: 'Processing',
                                    visibilityInPlayer: false,
                                    captionsRecentlyGenerated: false,
                                    captionsRecentlyProcessed: false
                                });
                                $scope.assetHasCaptions = true;
                            }

                            if (shouldShowRecentlyGeneratedCaptions) {
                                // highlight the most recently generated caption as green
                                $scope.captionsList.sort((a, b) => b.id - a.id);
                                $scope.captionsList[0].captionsRecentlyGenerated = true;
                            }
                        });
                    };

                    $scope.handleDeleteCaptionClick = function(caption) {
                        if (caption.status === 'Processing') return;
                        if (caption.source === 'ShareStream') return;
                        if (caption.source === 'Rev') return;
                        if (caption.source === 'CaptionSync') return;

                        avoidErrorForLanguageSelect = true;
                        setTimeout(function(){
                            avoidErrorForLanguageSelect = false;
                        }, 1000)

                        logger('handleDeleteCaptionClick')
                        $scope.confirmDeleteCaption(caption);
                    }

                    $scope.confirmDeleteCaption = function(caption) {
                        logger('confirmDeleteCaption')
                        var text = 'This action cannot be undone.';
                        $('#delete-modal-single #myModalHeadlineSingle').text('Delete Caption File?');
                        $('#delete-modal-single .modal-body p').text(text);
                        $('#delete-item-single').attr('data-action', 'deleteCaption');
                        $('#delete-item-single-span').text('Delete');
                        $scope.deletingCaption = caption;
                        $("#delete-modal-single").modal('show');
                    }

                    $scope.handleCloseModalClick = function(e) {
                        if($(e.target).parent().find('#delete-item-single').attr('data-action') === 'deleteCaption') {
                            setTimeout(function() {
                                var focused = false;
                                $('.languageValue').each(function(index, value) {
                                    if($(value).is(':visible') && !focused) {
                                        $(value).focus();
                                        focused = true;
                                    }
                                });
                            }, 100);
                        }
                    }

                    $scope.confirmOverwriteCaption = function(caption) {
                        logger('confirmOverwriteCaption')
                        var text = 'A captions file for this language has already been added. Uploading another captions file for this language will overwrite the current file and replace it with the new file.';
                        $('#delete-modal-single #myModalHeadlineSingle').text('Upload Captions and Overwrite Current Captions?');
                        $('#delete-modal-single .modal-body p').text(text);
                        $('#delete-item-single').attr('data-action', 'overwriteCaption');
                        $('#delete-item-single-span').text('Upload and Overwrite');
                        $scope.overwritingCaption = caption;
                        $("#delete-modal-single").modal('show');
                    }

                    $scope.confirmOverwritePreexistingCaptionsFile = function(caption) {
                        logger('confirmOverwritePreexistingCaptionsFile')
                        var text = 'There is a preexisting captions file for the language you have chosen for this Media Asset. Changing the language of the selected captions file to the language you have chosen will overwrite the preexisting captions file.';
                        $('#delete-modal-single #myModalHeadlineSingle').text('Overwrite Captions File?');
                        $('#delete-modal-single .modal-body p').text(text);
                        $('#delete-item-single').attr('data-action', 'overwriteCaption');
                        $('#delete-item-single-span').text('Overwrite');
                        $scope.overwritingCaption = caption;
                        $("#delete-modal-single").modal('show');
                    }

                    $scope.confirmGenerateAndOverwritePreexistingEnglishFile = function() {
                        logger('confirmGenerateAndOverwritePreexistingEnglishFile')
                        var text = 'A captions file for this language has already been added. Generating a captions file for this language will overwrite the current file and replace it with the new file.';
                        $('#delete-modal-single #myModalHeadlineSingle').text('Generate Captions and Overwrite Current Captions?');
                        $('#delete-modal-single .modal-body p').text(text);
                        $('#delete-item-single').attr('data-action', 'generateAndOverwriteEnglishCaption');
                        $('#delete-item-single-span').text('Generate Captions and Overwrite');
                        $("#delete-modal-single").modal('show');
                    }

                    $scope.confirmGenerateAndOverwritePreexistingEnglishFileCs = function(turnAroundTime) {
                        logger('confirmGenerateAndOverwritePreexistingEnglishFileCs')
                        var text = 'A captions file for this language has already been added. Generating a captions file for this language will overwrite the current file and replace it with the new file.';
                        $('#delete-modal-single #myModalHeadlineSingle').text('Generate Captions and Overwrite Current Captions?');
                        $('#delete-modal-single .modal-body p').text(text);
                        $('#delete-item-single').attr('data-action', 'generateAndOverwriteEnglishCaptionCs,' + turnAroundTime);
                        $('#delete-item-single-span').text('Generate Captions and Overwrite');
                        $("#delete-modal-single").modal('show');
                    }

                    $scope.deleteCaption = function(caption) {
                        logger('deleteCaption')

                        //If the ID is negative, i.e., the captions file was not uploaded yet with an associated language,
                        //we delete only from the dataTable, as the Delete API does not accept a captionId containing a
                        //negative number. We do this check before updating the flowplayer UI.
                        if(caption.id < 0) {
                            var captionIndex = $scope.captionsList.findIndex(p => p.id === caption.id);
                            $scope.captionsList.splice(captionIndex, 1);
                            $scope.captionsErrorState[caption.id] = false;
                            $('#fileUpload1').val('');
                            return;
                        }

                        //Hide the flowplayer UI
                        $scope.captionsupdated = false;

                        if(caption.status === 'Pending') {
                            $scope.captionsList = $scope.captionsList.filter(function(item) {
                                return item.id !== caption.id;
                            });

                            //Show the flowplayer UI
                            $scope.captionsupdated = true;
                            $scope.assetHasCaptions = $scope.captionsList.length > 0;
                            if($scope.captionsList.length === 0) {
                                $scope.sentForCaptioning = false;
                            }
                            if($scope.assetHasCaptions) {
                                $('#captionsDataTable').show();
                            } else {
                                $('#captionsEmptyState').css('display', 'flex');
                                document.getElementById('fileUpload').removeAttribute('disabled');
                            }
                            $scope.$apply();
                        } else {
                            AssetService.DeleteCaption.get({aid: assetId, id: caption.id}, function (result) {
                                getAsset();
                                setTimeout(() => {
                                    $scope.getCaptionsForAsset();

                                    //Show the flowplayer UI
                                    $scope.captionsupdated = true;

                                    if($scope.captionsList.length === 0) {
                                        $scope.sentForCaptioning = false;
                                    }

                                    $scope.captionsErrorState[caption.id] = false;

                                }, 2500);
                            });
                        }

                        $('#fileUpload1').val('');
                    }

                    $scope.toTitleCase = function(str) {
                          if (str === "ShareStream") {
                            return str;
                          }

                          if (str.toLowerCase() === "captionsync") {
                            return "CaptionSync";
                          }

                          return str.replace(
                            /\w\S*/g,
                            function(txt) {
                              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            }
                          );
                        }

                    $scope.downloadFile = function (caption) {
                        if (caption.status === 'Processing') return;
                        if (caption.status === 'Pending') return;
                        if (caption.id < 0) return;

                        logger('downloadFile')
                        console.log('downloading caption for asset: ',caption);
                        logger('getChat')
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: 'caption',
                            language: caption.language
                        }, function (result) {
                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }
                        });
                    };

                    $scope.downloadAudioTrack = function(track) {
                        if(!track || track.status === 'Processing' || !track.id) {
                            return;
                        }

                        logger('downloadAudioTrack');
                        var trackType = 'audioDescription';
                        if(track.type && track.type.toLowerCase().indexOf('audio description') === -1) {
                            trackType = 'audio';
                        }
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: trackType,
                            language: track.language || ''
                        }, function (result) {
                            var fileUrl = result.url,
                                fileName = result.name || track.fileName || track.displayName || 'audio-track';

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }
                        });
                    };

                    $scope.handleDeleteAudioTrackClick = function(track) {
                        if(!track || track.status === 'Processing') {
                            return;
                        }

                        logger('handleDeleteAudioTrackClick');
                        if(!$window.confirm('Delete this audio track? This action cannot be undone.')) {
                            return;
                        }

                        AssetService.DeleteAudioTrack.get({aid: assetId, id: track.id}, function () {
                            $scope.getAudioTracksForAsset(true);
                        });
                    };

                    $scope.handleSearchInputClick = function(e) {
                        logger('handleSearchInputClick');
                        e.preventDefault();
                    }

                    $scope.handleSearchInputContainerClick = function(e) {
                        logger('handleSearchInputContainerClick');
                        e.preventDefault();

                        var inputElement;

                        if(e.target.nodeName === 'DIV') {
                            inputElement = $(e.target).find('input.languageValue');
                        } else if (e.target.nodeName === 'INPUT') {
                            inputElement = $(e.target);
                        }

                        if(inputElement && inputElement.length && e.key !== 'Enter' && e.key !== ' ') {
                            inputElement[0].setSelectionRange(0,0);
                            inputElement[0].focus();
                        }
                    }

                    $scope.handleSearchInputMouseDown = function(e) {
                        logger('handleSearchInputMouseDown');
                        e.preventDefault();
                    }

                    //////////////////////////////////////
                    // Breadcrumb methods
                    //////////////////////////////////////
                    $scope.getCollectionTree = function() {
                        logger('getCollectionTree');

                        var intervalId = setInterval(() => {
                            if($scope.rootCollectionId) {
                                clearInterval(intervalId);
                                //rootCollectionId 2
                                CollectionService.GetCollectionTree.get({cid: $scope.rootCollectionId}, function (tree) {
                                    $scope.collectionTree = tree;
                                    $scope.collectionTree.show = false;
                                    // $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});

                                    //here
                                });
                            }
                        }, 100)
                    }

                    $scope.getCollectionTree();

                    $scope.handleBreadCrumbCurrentCollectionClick = function(cid) {
                        $scope.navigateToCollection({type: 'Collection', xid: cid})
                    }

                    $scope.navigateToCollection = function (content) {
                        logger('navigateToCollection');
                        $scope.goBack(content);
                    };

                    var generateCrumbs = function (cid, path) {
                        logger('generateCrumbs');
                        var crumbs = [];
                        if (path) {
                            var parents = path.split('/').slice(3);
                            if (parents.length) {
                                angular.forEach($scope.collectionTree.children, function (node) {
                                    getCrumbs(node, crumbs, cid, parents);
                                });
                            }
                        }
                        return crumbs;
                    };

                    // recursive function that gets all parent nodes of a collection from the collection tree
                    var getCrumbs = function (node, crumbs, cid, parents) {
                        logger('getCrumbs');
                        if (node.cid && parents.indexOf(node.cid) !== -1) {
                            crumbs.push({title: node.title, cid: node.cid});
                        }
                        angular.forEach(node.children, function (child) {
                            getCrumbs(child, crumbs, cid, parents);
                        });
                    };

                    $scope.handleStarKeyPress = function(e) {
                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $scope.toggleFavorite($scope.asset.cid, $scope.asset.aid);
                        }
                    }

                    // Menu methods
                    $scope.showMenu = function(e) {
                        logger('showMenu');

                        setTimeout(() => {
                            $('.generate-captions-menu').hide();
                            $('.caption-sync-submenu').hide();
                            $('.playback-menu').toggle();
                            var isMenuVisible = $('.playback-menu').is(':visible');
                            $(e.target).parent().parent().attr("aria-expanded",isMenuVisible);
                            if(isMenuVisible){
                                $('.playback-menu').find('[tabindex="0"]').first().focus();
                            }else{
                                $(e.target).parent().parent().focus();
                            }
                        }, 10);
                    }

                    $scope.menuMove = function(e) {
                        logger('menuMove');
                        $scope.openModal('Move', $scope.asset.aid);
                    }

                    $scope.menuCopy = function(e) {
                        logger('menuCopy');
                        $scope.openModal('Copy', $scope.asset.aid);
                    }

                    $scope.menuTranscript = function(e) {
                        logger('menuTranscript');
                        $scope.getTranscript($scope.asset.aid);
                    }

                    $scope.menuRename = function(e) {
                        logger('menuRename');
                        $('.playback .asset-title-editable').focus();
                    }

                    $scope.menuAddDescription = function(e) {
                        logger('menuAddDescription');
                        $('.playback .navbar-nav li:first-child a').click();
                        $('.playback .asset-description-editable').focus();
                    }

                    $scope.handleDescriptionKeyPress = function(e) {
                        logger('handleDescriptionKeyPress');

                        var maxLength = 4000;
                        var description = $(e.target).text();

                        if(description.length >= maxLength) {
                            e.preventDefault();
                        }

                        if(e.key === 'Enter') {
                            e.preventDefault();
                            e.target.blur();
                        }
                    }

                    $scope.handleDescriptionFocus = function(e) {
                        e.preventDefault();
                        e.target.scrollTo(0, 0);
                    }

                    $scope.handleDescriptionBlur = function(e) {
                        logger('handleDescriptionBlur');
                        $scope.persistAsset(e);
                    }

                    $scope.handleMenuIconKeyDown = function(e) {
                        logger('handleMenuIconKeyDown');

                        if(e.key === 'Escape') {
                            $('.playback-menu').hide();
                            $('.menu-icon').attr("aria-expanded","false");
                        }
                    }

                    $scope.handleLastMenuItemKeyDown = function(e) {
                        logger('handleLastMenuItemKeyDown');

                        if(e.which === 9 && !e.shiftKey) {
                            e.preventDefault();
                            $(e.target).parent().parent().parent().children('.menu-icon').focus();
                        }
                        $scope.closeMenuAndFocusOnMenuIcon(e);
                    }

                    $scope.closeMenuAndFocusOnMenuIcon = function(e) {
                        logger('closeMenuAndFocusOnMenuIcon');
                        if(e.which === 27) {
                            $('.menu').hide();
                            $(".menu-icon").attr("aria-expanded","false");
                            var menuButton = $(e.target).parent().parent().parent().children('.menu-icon');
                            //if menuButton does not exist then target must be availibility switch that requires another search
                            if(!menuButton.length){
                                menuButton = $(e.target).parent().parent().parent().parent().parent().parent().children('.menu-icon');
                            }
                            menuButton.focus();
                        }
                    }

                    $scope.handleMenuRenameKeyPress = function(e) {
                        logger('handleMenuRenameKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $('.playback .asset-title-editable').focus();
                            $('.playback-menu').hide();
                            $('.menu-icon').attr("aria-expanded","false");
                        }
                    }

                    $scope.handleMenuEditDescriptionKeyPress = function(e) {
                        logger('handleMenuEditDescriptionKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $('.playback .asset-description-editable').focus();
                            $('.playback-menu').hide();
                            $('.menu-icon').attr("aria-expanded","false");
                        }
                    }

                    $scope.handleMenuMoveKeyPress = function(e) {
                        logger('handleMenuMoveKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $scope.menuMove(e);
                        }
                    }

                    $scope.handleMenuCopyKeyPress = function (e) {
                        logger('handleMenuCopyKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $scope.menuCopy(e);
                        }
                    }

                    $scope.handleMenuTranscriptKeyPress = function (e) {
                        logger('handleMenuTranscriptKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $scope.menuTranscript(e);
                        }
                    }

                    $scope.handleMenuDeleteKeyPress = function (e) {
                        logger('handleMenuDeleteKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $scope.confirmDelete(e);
                        }
                    }

                    $scope.handleMenuKeydown = function(e) {
                        logger('handleMenuKeydown');

                        if(e.key === 'Escape') {
                            $('.playback-menu').hide();
                            $('.menu-icon').attr("aria-expanded","false");
                            $('.menu-icon').focus();
                        }
                    }

                    $scope.handleMenuIconKeyPress = function(e) {
                        logger('handleMenuIconKeyPress');

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $('.generate-captions-menu').hide();
                            $('.caption-sync-submenu').hide();
                            $('.playback-menu').toggle();
                            var isMenuVisible = $('.playback-menu').is(':visible');
                            $(e.target).attr("aria-expanded",isMenuVisible);
                            if(isMenuVisible){
                                $('.playback-menu').find('[tabindex="0"]').first().focus();
                            }else{
                                $(e.target).focus();
                            }
                        }
                    }

                    $scope.openModal = function (type, xid) {
                        logger('openModal');
                        var filteredArray = $scope.collectionContent.filter((el) => {
                            return el.xid == $scope.asset.aid;
                        });

                        console.log('filteredArray: ', filteredArray);
                        $timeout(function(){
                             $scope.content = {
                                 type: type,
                                 item: filteredArray,
                             }
                             // Modal is being called empty
                             $("#itemManagementWindow").modal('show')
                                 .on('shown.bs.modal', function () {
                                     modalFocus('#publishHeading', '#returnTopublishHeading');
                                 })
                                 .on('hidden.bs.modal', function () {
                                     var hiddenCollectionId = $('#hiddenCollectionId').val();
                                     if (hiddenCollectionId) {
                                         collectionId = $('#hiddenCollectionId').val();
                                         if ($window.location.hash.indexOf("#/lms/playback/") === 0) {
                                             $state.go('lmsPlayback', {
                                                 collectionType: collectionType,
                                                 collectionId: hiddenCollectionId,
                                                 assetId: assetId
                                             });
                                         }
                                         else {
                                             $state.go('playback', {
                                                 collectionType: collectionType,
                                                 collectionId: hiddenCollectionId,
                                                 assetId: assetId
                                             });
                                         }
                                     }
                                 });
                        });
                    };

                    $scope.confirmDelete = function (e) {
                        logger('confirmDelete');
                        var title = $scope.asset.title;
                        var isCollection = $scope.asset.type === "Collection";
                        var text = isCollection ? 'Deleting the “' + title + '” Folder will delete the Folder as well as any items stored in it. This action cannot be undone.' : 'This action cannot be undone.';
                        $('#delete-modal-single #myModalHeadlineSingle').text(isCollection ? 'Delete Folder?' : 'Delete Media Asset?');
                        $('#delete-modal-single .modal-body p').text(text);
                        $('#delete-item-single').attr('data-action', 'deleteAsset');
                        $('#delete-item-single-span').text('Delete');
                        $("#delete-modal-single").modal('show');
                        $scope.selected = e;
                    };

                    $scope.deleteAsset = function () {
                        logger('deleteAsset');
                        var xids = [];
                        var xid = $scope.asset.aid;
                        xids.push(xid);

                        var items = [];
                        var item = {};

                        $scope.asset.parent = {cid: $scope.collectionId};
                        $scope.asset.xid = $scope.asset.aid;
                        item.collectionContentDTO = $scope.asset;
                        item.destinationCollectionId = ($scope.currentcollection && $scope.currentcollection.cid) || $scope.collectionId;
                        items.push(item);
                        var deleteItem = new BaseFileService.DeleteItem({
                            contents: items,
                            totalContents: items.length
                        });

                        $("#delete-modal-single").modal('hide');

                        deleteItem.$save(function (response) {
                            console.log('deleteItem resp: ', response);
                            //redirect to the parent collection's PnP page
                            $scope.navigateToCollection({type: 'Collection', xid: $scope.asset.cid})
                        });
                    }

                    var modalConfirmSingle = function(callback){
                        logger('modalConfirmSingle');
                        $("#delete-item-single").on("click", function(){
                            callback(true);
                            $("#delete-modal-single").modal('hide');
                        });

                        $("#modal-btn-close-single").on("click", function(){
                            $("#delete-modal-single").modal('hide');
                            callback(false);
                        });

                        $("#modal-btn-close").on("click", function(){
                            var primaryButtonContent = $('#delete-item-single-span').text();
                            if(primaryButtonContent === 'Overwrite') {
                                revertToPreviousCaptionLanguage();
                            } else if (primaryButtonContent === 'Upload and Overwrite') {
                                removeNewCaptionFromDatatable();
                            }

                            $("#delete-modal-single").modal('hide');
                        });
                    };

                    modalConfirmSingle(function(confirm){
                        if(confirm){
                            if($('#delete-item-single').attr('data-action') === 'deleteCaption') {
                                $scope.deleteCaption($scope.deletingCaption);
                            }

                            if($('#delete-item-single').attr('data-action') === 'deleteAsset') {
                                $scope.deleteAsset();
                            }

                            if($('#delete-item-single').attr('data-action') === 'overwriteCaption') {
                                $scope.saveCaption($scope.overwritingCaption);
                            }

                            if($('#delete-item-single').attr('data-action') === 'generateAndOverwriteEnglishCaption') {
                                $scope.sendFileForCaptioning($scope.asset.aid, false, null);
                            }

                            if($('#delete-item-single').attr('data-action').indexOf('generateAndOverwriteEnglishCaptionCs') > -1) {
                                var turnAroundTime =  $('#delete-item-single').attr('data-action').split(',')[1];
                                $scope.sendFileForCaptioning($scope.asset.aid, true, turnAroundTime);
                            }
                        }else{
                        }
                    });

                    $scope.handleModalBtnCloseX = function() {
                        logger('handleModalBtnCloseX');

                        var primaryButtonContent = $('#delete-item-single-span').text();

                        if(primaryButtonContent === 'Overwrite') {
                            revertToPreviousCaptionLanguage();
                        } else if (primaryButtonContent === 'Upload and Overwrite') {
                            removeNewCaptionFromDatatable();
                        } else if (primaryButtonContent === 'Generate Captions and Overwrite') {
                            removeEnglishCaptionFromDatatable();
                        }
                    }
                    var revertToPreviousCaptionLanguage = function() {
                        logger('revertToPreviousCaptionLanguage');
                        $('#captionsDataTable input.languageValue').each( function(index, item) {
                            if( $(item).attr('data-caption-id').toString() === $scope.updatingCaption.id.toString()) {
                                $(item).prop('value', $scope.updatingCaption.title);
                                var captionToUpdate = $scope.captionsList.find(p => p.id === $scope.updatingCaption.id);
                                captionToUpdate.language = $scope.updatingCaption.title;
                            }
                        });
                    }
                    var removeNewCaptionFromDatatable = function() {
                        logger('removeNewCaptionFromDatatable');
                        $scope.captionsList.forEach(function(item, index){
                            if(item.captionsRecentlyProcessed) {
                                $scope.captionsList.splice(index, 1);
                                $scope.$apply();
                            }
                        });
                        $('#fileUpload1').val('');
                    }

                    $scope.handleAssetTitleBlur = function(e) {
                        logger('handleAssetTitleBlur');

                        var elAssetTitle = e.target;
                        if( $(elAssetTitle).text().trim() === '' ) {
                            $(elAssetTitle).text('Untitled Asset');
                        }

                        $scope.persistAsset(e);
                        e.target.scrollTo(0, 0);
                    }

                    $scope.handleMenuQuizKeyPress = function(e) {
                        if($scope.logEventHandlers) {
                            console.log('handleMenuQuizKeyPress')
                        }
                        if(e.which === 13 || e.which === 32) {
                            $scope.createQuiz(e);
                        }
                    }

                    $scope.handleAssetTitleKeyPress = function (e) {
                        if(e.key === 'Enter') {
                            e.preventDefault();
                            e.target.blur();
                        }
                    }

                    $scope.handleAssetTitleFocus = function (e) {
                        e.target.innerText = $scope.asset.title;
                    }

                    $scope.persistAsset = function(e) {
                        logger('persistAsset');

                        if(e.target.classList.contains('asset-title-editable')) {
                            $scope.asset.title = $('.playback .asset-title-editable').text().trim();
                        }

                        var description = $('.playback .asset-description-editable')[0].innerText.trim();

                        $scope.asset.description = description;

                        var collectionContentDTO = $scope.asset;
                        collectionContentDTO.parent = {cid: $scope.asset.cid};
                        collectionContentDTO.xid = $scope.asset.aid;

                        var updateItem = new BaseFileService.UpdateItem({
                            collectionContentDTO: collectionContentDTO,
                            destinationCollectionId: $scope.asset.cid
                        });

                        updateItem.$save(function (response) {
                            console.log('updateItem resp: ', response);
                            var assetTitle = $('.asset-title-editable')[0];

                            if(e.target.classList.contains('asset-title-editable')) {
                                $clamp(assetTitle, {clamp: 3, useNativeClamp: false});
                            }

                            $scope.menuDescriptionText = $scope.asset.description.trim() === "" ? 'Add Description' : 'Edit Description';
                        }, function () {});
                    }

                    $scope.$watch('asset', function() {
                        logger('watch asset');

                        if($scope.asset) {
                            $scope.menuDescriptionText = $scope.asset.description && $scope.asset.description.trim().length ? 'Edit Description' : 'Add Description';
                            $scope.hasWritePermissions = $scope.asset.acl.indexOf('W') > -1;
                            if(!$scope.hasWritePermissions) {
                                $('.transcript-button').css('display', 'flex');
                            }

                            $scope.rootCollectionId = $scope.asset.rootLevelCid;
                            $rootScope.rootLevelCid = $scope.asset.rootLevelCid;
                            $rootScope.rootCollectionId = $scope.asset.rootLevelCid;
                            $scope.hideCurrentFolderOnBreadcrumb = !$scope.rootCollectionId;

                            $scope.getCollections();

                            //If we try to display the description value directly in playback.html using th e {{asset.description}} syntax,
                            //the line breaks will not work.
                            setTimeout(() => {
                                var description = $scope.asset.description.trim();
                                description = description.replaceAll('\n', '<br>');
                                $('.asset-description-editable').html(description);

                                if($('.asset-title').length) {
                                    var assetTitle = $('.asset-title')[0];
                                    $clamp(assetTitle, {clamp: 2, useNativeClamp: false});
                                }

                                if($('.asset-title-editable').length) {
                                    var assetTitleEditable = $('.asset-title-editable')[0];
                                    $clamp(assetTitleEditable, {clamp: 3, useNativeClamp: false});
                                }

                                if($('.asset-title').text().indexOf('…') > -1) {
                                    $scope.showTitleTooltip = true;
                                }
                            }, 100);
                        }
                    });

                    $scope.allowGenerateCaptions = false;
                    $scope.$watch('captionsList', function() {
                        if($scope.captionsList) {
                           $scope.allowGenerateCaptions = $scope.captionsList.filter(p => p.source.toLowerCase() !== 'manual upload').length === 0;
                        }
                    }, true);

                    var avoidErrorForLanguageSelect = false;
                    $scope.handleSearchInputBlur = function(e, captionId) {
                        logger('handleSearchInputBlur');
                        var languageCandidate = $(e.target).val();
                        var languageList = languages.find(p => p.language === languageCandidate);

                        if(languageList) {
                            $(e.target).parents('.searchFieldContainer').find('.clearButton').hide();
                        }

                        if(e.target.value === '') {
                            var caption = $scope.captionsList.find(p => p.id === captionId);

                            setTimeout(function(){
                                if(caption.status !== 'Pending' && !avoidErrorForLanguageSelect) {
                                    $scope.captionsErrorState[captionId] = true;
                                    $scope.$apply();

                                    $(e.target).parents('.datatableRow').find('.status').removeClass('published');
                                    $(e.target).parents('.datatableRow').find('.status').removeClass('pending');
                                    $(e.target).parents('.datatableRow').removeClass('datatable-recently-processed');
                                    $(e.target).parents('.datatableRow').find('.status').addClass('error');
                                }
                                $(e.target).parents('.datatableRow').find('.clearButton').hide();
                                $(e.target).parents('.datatableRow').find('.caretIcon').show();
                            }, 300)

                        }
                    }

                    $scope.handleSearchCaretKeyUp = function(e) {
                        logger('handleSearchCaretKeyPress');
                        if(e.key === 'Enter' || e.key === ' ') {
                            $(e.target).click();

                            setTimeout(function() {
                                $(e.target).focus();
                                // rotateCaretIcon($(e.target).parents('.searchFieldContainer').find('.caretIconButton img'));
                            }, 50)
                        }
                    }

                    $scope.handleSearchCaretKeyDown = function(e, captionId) {
                        logger('handleSearchCaretKeyDown');

                        if(e.key === 'Tab' && !e.shiftKey) {
                            if($(e.target).parents('.searchFieldContainer').find('.languageValue').val().trim() === '') {
                                $scope.captionsErrorState[captionId] = true;
                                var caption = $scope.captionsList.find(p => p.id === captionId);
                                caption.status = 'Error';
                            }
                        }
                    }

                    $scope.handleSearchClearKeyUp = function(e) {
                        logger('handleSearchClearKeyUp');

                        if(e.key === 'Enter' || e.key === ' ') {
                            $(e.target).click();
                        }
                    }

                    $scope.handleSearchClearKeyDown = function(e, captionId) {
                        logger('handleSearchClearKeyDown');

                        if($(e.target).parents('.searchFieldContainer').find('.languageNoResults').is(':visible')) {
                            $(e.target).parents('.searchFieldContainer').find('.languageNoResults').hide();
                            $(e.target).parents('.searchFieldContainer').find('.languageSearchResults').hide();
                            $(e.target).parents('.searchFieldContainer').find('.languageValue').val('');
                            $scope.captionsErrorState[captionId] = true;
                            var caption = $scope.captionsList.find(p => p.id === captionId);
                            caption.status = 'Error';

                            $(e.target).parents('.searchFieldContainer').find('.clearButton').hide();
                            $(e.target).parents('.searchFieldContainer').find('.caretIconButton').show();
                        }
                    }

                    $scope.handleSearchFieldContainerBlur = function(e) {
                        logger('handleSearchFieldContainerBlur');
                        $(e.target).find('.languageSearchResults').hide();
                    }

                    $scope.handleSearchFieldContainerKeyDown = function(e) {
                        logger('handleSearchFieldContainerKeyDown');
                        if(e.key === 'ArrowDown') {
                            $scope.handleLanguageSearchKeyDown(e);
                        }
                    }

                    $scope.handleLanguageSearchKeyDown = function (e) {
                        if(e.key === 'ArrowDown') {
                            $scope.filteredLanguages = languages;
                            setTimeout(function(){
                                $scope.$apply();
                            }, 0)

                            var targetElement = e.target.classList.contains('searchFieldContainerBorder') ? e.target.parentElement : e.target;
                            $(targetElement).find('.languageSearchResults').show();
                            rotateCaretIcon($(targetElement).find('.caretIconButton img'));

                            setTimeout(function(){
                                $(targetElement).find('.languageSearchResults li:first-child').focus();
                            }, 50);
                        }


                        if(e.key === 'Escape') {
                            if( $(e.target).parent().find('.languageSearchResults').is(':visible') ) {
                                $(e.target).parent().find('.languageSearchResults').hide();
                            } else {
                                $(e.target).find('input.languageValue').val('');
                                $(e.target).find('input.languageValue').focus();
                            }
                        }
                    }

                    $scope.handleSearchResultsListItemKeyDown = function(e) {
                        logger('handleSearchResultsListItemKeyDown');
                        e.stopPropagation();

                        if(e.key === 'Enter' || e.key === ' ') {
                            $(e.target).css({'background': '#000000', 'color': '#FFFFFF'});
                        }

                        if(e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Tab') {
                            e.preventDefault();
                        }

                        if(e.key === 'ArrowUp') {
                            if(e.target.previousSibling.previousSibling.nodeName === 'LI') {
                                e.target.previousSibling.previousSibling.focus();
                            }
                        }

                        if(e.key === 'ArrowDown') {
                            if(e.target.nextSibling.nextSibling.nodeName === 'LI') {
                                e.target.nextSibling.nextSibling.focus();
                            }
                        }

                        if(e.key === 'Tab' && !e.shiftKey) {
                            $(e.target).parents('tr').find('.deleteCaptionIcon').focus();
                            $(e.target).parents('tr').find('.languageSearchResults').hide();
                            rotateCaretIcon($(e.target).parents('.searchFieldContainer').find('.caretIconButton img'));
                        }
                    }

                    $scope.handleSearchResultsListItemKeyUp = function(e) {
                        if(e.key === 'Escape') {
                            $(e.target).parents('.searchFieldContainer').find('.languageSearchResults').hide();
                            $(e.target).parents('.searchFieldContainer').find('input.languageValue').focus();
                        }

                        if(e.key === 'Enter' || e.key === ' ') {
                            $(e.target).click();
                            $(e.target).css({'background': '#FFFFFF', 'color': '#000000'});
                        }
                    }

                    $scope.handleBreadcrumbDownArrowClick = function(e) {
                        $scope.showCollectionTree = !$scope.showCollectionTree;
                    }

                    //Using SVG in code as PD1 was not able to load these images from the assets/images folder
                    var imgFolderClosed = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '    <path d="M18 20H6C4.89688 20 4 19.1031 4 18V11H20V18C20 19.1031 19.1031 20 18 20ZM20 10H4V8C4 6.89688 4.89688 6 6 6H10C10.6281 6 11.2219 6.29687 11.6 6.8L12.2 7.6C12.3875 7.85312 12.6844 8 13 8H18C19.1031 8 20 8.89687 20 10Z" fill="#2A6FD9"/>' +
                        '</svg>';

                    var imgFolderOpened = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '    <path d="M5.77187 11.9938L3 16.7437V8C3 6.89688 3.89688 6 5 6H8.67188C9.20312 6 9.7125 6.20938 10.0875 6.58438L10.9156 7.4125C11.2906 7.7875 11.8 7.99688 12.3313 7.99688H16C17.1031 7.99688 18 8.89375 18 9.99687V10.9969H7.5C6.7875 10.9969 6.13125 11.375 5.77187 11.9906V11.9938ZM6.63438 12.4969C6.81563 12.1875 7.14375 12 7.5 12H20C20.3594 12 20.6875 12.1906 20.8656 12.5031C21.0438 12.8156 21.0437 13.1969 20.8625 13.5063L17.3625 19.5063C17.1844 19.8125 16.8562 20 16.5 20H4C3.64062 20 3.3125 19.8094 3.13438 19.4969C2.95625 19.1844 2.95625 18.8031 3.1375 18.4937L6.6375 12.4938L6.63438 12.4969Z" fill="#2A6FD9"/>' +
                        '</svg>';

                    $scope.$watch('showCollectionTree', function() {
                        if($scope.showCollectionTree) {
                            var rootLeft =  parseInt($('.breadcrumb .root-container').width());
                            $('.collection-tree').css('left', rootLeft - 36);

                            $('.collection-tree .results').css('padding', '12px 8px');
                            $('.collection-tree').css('top', '34px');
                            setTimeout(() => {
                                $('.collection-tree .folder-image').html(imgFolderClosed);
                            }, 100)
                        }
                    });

                    $scope.handleCollectionTreeChevronClick = function(e, child) {
                        e.stopPropagation();

                        var decodedChild = $scope.decodedChild = child;

                        try {
                            decodedChild = $scope.decodedChild = JSON.parse(atob(child));
                        } catch(e) {
                        }

                        var clickedChevron = e.target;

                        //Folder is opened. Close it.
                        //If the image is already rotated, it means that the folder is opened
                        if($(clickedChevron).css('transform').indexOf('matrix') > -1) {
                            $(e.target).parents('.result-item').children('.folder-image').html(imgFolderClosed);
                            //Chevron to the right
                            $(clickedChevron).css('transform', '');

                            //Remove the subfolders
                            $(e.target).parents('.result-item').siblings('ul').remove();

                            return;

                        } else {
                            //Folder is closed. Open it.
                            $(e.target).parents('.result-item').children('.folder-image').html(imgFolderOpened);

                            //Chevron down
                            $(clickedChevron).css('transform', 'rotate(90deg)');
                        }

                        var newElement = "<ul class='results'>";

                        //Loop in decodedChild.children
                        for(var i = 0; i < decodedChild.children.length; i++) {
                            newElement += "<li class='result-item' ng-click='navigateToCollection({type: \"Collection\", xid: \"" + decodedChild.children[i].cid + "\"})'>";

                            //If there are subfolders, add the chevron icon
                            if(decodedChild.children[i].children.length) {
                                newElement += "<div class='chevron-container' ng-click='handleCollectionTreeChevronClick($event, \"" + btoa(JSON.stringify(decodedChild.children[i])) + "\")'>" +
                                    "<img class='chevron' src='assets/images/chevron-right.svg'>" +
                                    "</div>";
                            } else {
                                //Otherwise, add space to replace the chevron icon
                                newElement += "<div style='width: 36px'></div>";
                            }

                            //Add folder closed icon and title
                            newElement += "<div class='folder-image'>" + imgFolderClosed + "</div>" +
                                "<span class='title'>" + decodedChild.children[i].title + "</span>" +
                                "</div>" +
                                "</li>";
                        }

                        newElement += "</ul>";

                        var compiledElement = $compile(newElement)($scope);
                        angular.element($(e.target).parents('.result-item')[0]).after(compiledElement[0]);
                    }

                    $scope.handleNavigationTabKeyDown = function(e) {
                        logger('handleDescriptionTabKeyDown');

                        if(e.key === 'ArrowRight') {
                            e.preventDefault();

                            if($(e.target).parent().next().length) {
                                $(e.target).parent().next().find('a').focus();
                            }
                        }

                        if(e.key === 'ArrowLeft') {
                            e.preventDefault();

                            if($(e.target).parent().prev().length) {
                                $(e.target).parent().prev().find('a').focus();
                            }
                        }

                        if(e.key === ' ') {
                            e.preventDefault();

                            if($(e.target).text().indexOf('Comments') > -1) {
                                $scope.handleCommentsTabClick(e);
                            }

                            if($(e.target).text().indexOf('Description') > -1) {
                                $scope.handleDescriptionTabClick(e);
                            }

                            if($(e.target).text().indexOf('Captions') > -1) {
                                $scope.handleCaptionsTabClick(e);
                            }
                        }
                    }

                    $scope.handleBreadcrumbRootContainerClick = function(cid) {
                        logger('handleBreadcrumbRootContainerClick');
                        //if down arrow is visible
                        // if($scope.currentCollection.cid === $scope.rootCollectionId) {
                        //     $scope.showCollectionTree = !$scope.showCollectionTree;
                        //
                        //     setTimeout(function(){
                        //         $('.collection-tree .search input').focus();
                        //     },100)
                        // } else {
                            $scope.navigateToCollection({type: 'Collection', xid: cid})
                        // }
                    }

                    $scope.handleOrderFromCaptionSyncClick = function(e) {
                        logger('handleOrderFromCaptionSyncClick');

                        //show submenu
                        $('.caption-sync-submenu').show();
                    }

                    $scope.handleBreadcrumbEllipsisClick = function(e) {
                        $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').toggle();

                        setTimeout(function(){
                            if($(e.target).parents('.breadcrumb').find('.breadcrumb-menu').is(':visible')) {
                                var intervalId = setInterval(function(){
                                    if($('.breadcrumb-menu li:nth-child(1) > div > span')[0].offsetWidth) {
                                        clearInterval(intervalId);

                                        //check each LI if there's ellipsis
                                        for(var i = 0; i < $('.breadcrumb-menu li').length; i++) {
                                            if(hasEllipsisWidth($('.breadcrumb-menu li:nth-child(' + (i + 1) + ') > div > span')[0])) {
                                                $scope.crumbsForMenu[i].hasEllipsis = true;
                                            } else {
                                                $scope.crumbsForMenu[i].hasEllipsis = false;
                                            }
                                        }
                                    }
                                }, 100);
                                $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').find('[tabindex="0"]').first().focus();
                                $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",true);
                            }else{
                                $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                            }
                        }, 100);
                    };
                    $scope.handleBreadcrumbMenuItemClick = function(e, cid) {
                        $scope.navigateToCollection({type: 'Collection', xid: cid});
                        $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').hide();
                        $(e.target).parents('.breadcrumb').find('.elipse').attr("aria-expanded",false);
                    }

                    $scope.handleMenuKeyUp = function(e) {
                        if(e.key === 'Escape') {
                            $('.menu').hide();
                            $(".menu-icon").attr("aria-expanded","false");
                        }
                    }

                    $scope.disableGenerateCaptionsButton = false;
                    $scope.$watch('sentForCaptioning', function() {
                        //If the user has authorization to CaptionSync and clicked on  Order from ShareStream,
                        //do not disable the Generate Captions button.
                        if($scope.sentForCaptioning && $scope.showCaptionsyncButton) {
                            $scope.disableGenerateCaptionsButton = false;
                        }

                        //If the user does not have authorization to CaptionSync and clicked on Generate Captions,
                        //do not disable the Generate Captions button.
                        if(!$scope.showCaptionsyncButton && $scope.sentForCaptioning) {
                            $scope.disableGenerateCaptionsButton = true;
                        }
                    })

                    $scope.$watch('sentForCaptioningCs', function() {
                        //If the user has authorization to CaptionSync
                        //and clicked on one of the Order from CaptionSync options,
                        //disable the Generate Captions button. Otherwise, keep it enabled.
                        $scope.disableGenerateCaptionsButton = $scope.sentForCaptioningCs;
                    })

                    $scope.handleTranscriptButtonStudentClick = function() {
                        logger('handleTranscriptButtonStudentClick');
                        $scope.getTranscript($scope.asset.aid);
                    }

                    $scope.handleTranscriptButtonStudentKeypress = function(e) {
                        logger('handleTranscriptButtonStudentKeypress');
                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $scope.getTranscript($scope.asset.aid);
                        }
                    }

                    $scope.handleSearchFieldContainerBorderKeyDown = function(e) {
                        logger('handleSearchFieldContainerBorderKeyDown');

                        if(e.key === 'Tab' && e.shiftKey) {
                            $(e.target).parents('.searchFieldContainer').find('.languageSearchResults').hide();
                            $(e.target).parents('.searchFieldContainer').find('.languageNoResults').hide();
                        }
                    }

                    $scope.hideMenuWhenClickOutside = function(e) {
                        logger('hideMenuWhenClickOutside');

                        var menuCandidate = $(e.target);
                        var isMenu = $(menuCandidate).hasClass('menu');
                        var isMenuButtonChild = $(menuCandidate).parent().hasClass('menu-button');
                        var isMenuButton = $(menuCandidate).hasClass('menu-button');
                        var isMenuItem = $(menuCandidate).parents('.menu').length;

                        if(!isMenu && !isMenuButtonChild && !isMenuButton && !isMenuItem) {
                            $('.generate-captions-menu').hide();
                            $('.caption-sync-submenu').hide();

                            if( $('.menu-button .arrow').length ) {
                                $('.menu-button .arrow').css('transform', 'rotate(180deg)');
                            }
                        }
                        //Clicked element is not SearchResults and not language (input?)
                        if(
                            !e.target.classList.contains('languageSearchResults')
                            && !e.target.classList.contains('language')
                        ) {
                            $('.languageSearchResults').hide();
                            $('.languageNoResults').hide();
                            showDownCaretIcon($('.caretIcon'));
                            $('.clearButton').hide();
                        }

                        //If the typed text does not correspond to an existing language, clear input.
                        $('input.languageValue').each(function(index, item) {
                            var languageCandidate = languages.find(p => p.title === $(item).val().trim());

                            if(!languageCandidate) {
                                $(item).val('');
                            }
                        });

                        //If clicked outside the menu items and not in the menu icon, hide menu
                        if(!$(e.target).hasClass('playback-menu') &&
                            !$(e.target).parents('.menu-icon').length) {
                            var isMenuVisible = $('.playback-menu').is(':visible');
                            if(isMenuVisible){
                                $('.playback-menu').hide();
                                $('.menu-icon').attr("aria-expanded","false");
                            }
                            return;
                        }
                    }

                    $scope.hideBreadcrumbTreeViewWhenClickOutside = function(e) {
                        logger('hideBreadcrumbTreeViewWhenClickOutside');
                        var isTreeView = $(e.target).parents('.collection-tree').length > 0;
                        var isDropDown = $(e.target).parents('.down-arrow').length > 0 || $(e.target).hasClass('down-arrow');
                        var isBreadcrumbRoot = $(e.target).parents('.breadcrumb').find('.root-container').length > 0;

                        $timeout(function () {
                            if(!isTreeView && !isDropDown && !isBreadcrumbRoot) {
                                $scope.showCollectionTree = false;
                            }
                        });
                    }

                    $scope.hideBreadcrumbMenuWhenClickOutside = function(e){
                        if(!$(e.target).hasClass("breadcrumb-menu") &&
                            $(e.target).parents(".breadcrumb-menu").length ===0 &&
                            !$(e.target).hasClass("ellipsis") &&
                            $(e.target).parents(".ellipsis").length === 0){
                            if($(".breadcrumb-menu").is(":visible")){
                                $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                                $('.breadcrumb-menu').hide();
                            }
                        }
                    };

                    $(document).on("keydown.playback", function (e) {
                        if (e.which === 27) {
                            $scope.showCollectionTree = false;
                            $scope.$apply();
                            if($(".breadcrumb-menu").is(":visible")){
                                $(".breadcrumb-menu:visible").parents('.breadcrumb').find('.ellipsis').first().focus();
                                $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                                $('.breadcrumb-menu').hide();
                            }
                            $('.tooltip').hide();
                        }
                    });

                    $(window).on("click.playback", function(e) {
                        $scope.hideBreadcrumbTreeViewWhenClickOutside(e);
                        $scope.hideMenuWhenClickOutside(e);
                        $scope.hideBreadcrumbMenuWhenClickOutside(e);
                    });

                    $scope.$on('$destroy', function() {
                        console.log('playback.controller.js controller is being destroyed, performing cleanup...');
                        $(document).off("keydown.playback");
                        $(window).off("click.playback");
                    });

                 }
            });
        });
    });
